//@ts-nocheck
  // DO NOT MODIFY THIS FILE. This file is automatically generated by Tina
  export function gql(strings: TemplateStringsArray, ...args: string[]): string {
    let str = ''
    strings.forEach((string, i) => {
      str += string + (args[i] || '')
    })
    return str
  }
  export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  /** References another document, used as a foreign key */
  Reference: { input: any; output: any; }
  JSON: { input: any; output: any; }
};

export type SystemInfo = {
  __typename?: 'SystemInfo';
  filename: Scalars['String']['output'];
  title?: Maybe<Scalars['String']['output']>;
  basename: Scalars['String']['output'];
  breadcrumbs: Array<Scalars['String']['output']>;
  path: Scalars['String']['output'];
  relativePath: Scalars['String']['output'];
  extension: Scalars['String']['output'];
  template: Scalars['String']['output'];
  collection: Collection;
};


export type SystemInfoBreadcrumbsArgs = {
  excludeExtension?: InputMaybe<Scalars['Boolean']['input']>;
};

export type Folder = {
  __typename?: 'Folder';
  name: Scalars['String']['output'];
  path: Scalars['String']['output'];
};

export type PageInfo = {
  __typename?: 'PageInfo';
  hasPreviousPage: Scalars['Boolean']['output'];
  hasNextPage: Scalars['Boolean']['output'];
  startCursor: Scalars['String']['output'];
  endCursor: Scalars['String']['output'];
};

export type Node = {
  id: Scalars['ID']['output'];
};

export type Document = {
  id: Scalars['ID']['output'];
  _sys?: Maybe<SystemInfo>;
  _values: Scalars['JSON']['output'];
};

/** A relay-compliant pagination connection */
export type Connection = {
  totalCount: Scalars['Float']['output'];
  pageInfo: PageInfo;
};

export type Query = {
  __typename?: 'Query';
  getOptimizedQuery?: Maybe<Scalars['String']['output']>;
  collection: Collection;
  collections: Array<Collection>;
  node: Node;
  document: DocumentNode;
  skill: Skill;
  skillConnection: SkillConnection;
  technique: Technique;
  techniqueConnection: TechniqueConnection;
  art: Art;
  artConnection: ArtConnection;
  move: Move;
  moveConnection: MoveConnection;
  exercise: Exercise;
  exerciseConnection: ExerciseConnection;
  course: Course;
  courseConnection: CourseConnection;
  awfulpractice: Awfulpractice;
  awfulpracticeConnection: AwfulpracticeConnection;
  routines: Routines;
  routinesConnection: RoutinesConnection;
};


export type QueryGetOptimizedQueryArgs = {
  queryString: Scalars['String']['input'];
};


export type QueryCollectionArgs = {
  collection?: InputMaybe<Scalars['String']['input']>;
};


export type QueryNodeArgs = {
  id?: InputMaybe<Scalars['String']['input']>;
};


export type QueryDocumentArgs = {
  collection?: InputMaybe<Scalars['String']['input']>;
  relativePath?: InputMaybe<Scalars['String']['input']>;
};


export type QuerySkillArgs = {
  relativePath?: InputMaybe<Scalars['String']['input']>;
};


export type QuerySkillConnectionArgs = {
  before?: InputMaybe<Scalars['String']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Float']['input']>;
  last?: InputMaybe<Scalars['Float']['input']>;
  sort?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<SkillFilter>;
};


export type QueryTechniqueArgs = {
  relativePath?: InputMaybe<Scalars['String']['input']>;
};


export type QueryTechniqueConnectionArgs = {
  before?: InputMaybe<Scalars['String']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Float']['input']>;
  last?: InputMaybe<Scalars['Float']['input']>;
  sort?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<TechniqueFilter>;
};


export type QueryArtArgs = {
  relativePath?: InputMaybe<Scalars['String']['input']>;
};


export type QueryArtConnectionArgs = {
  before?: InputMaybe<Scalars['String']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Float']['input']>;
  last?: InputMaybe<Scalars['Float']['input']>;
  sort?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<ArtFilter>;
};


export type QueryMoveArgs = {
  relativePath?: InputMaybe<Scalars['String']['input']>;
};


export type QueryMoveConnectionArgs = {
  before?: InputMaybe<Scalars['String']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Float']['input']>;
  last?: InputMaybe<Scalars['Float']['input']>;
  sort?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<MoveFilter>;
};


export type QueryExerciseArgs = {
  relativePath?: InputMaybe<Scalars['String']['input']>;
};


export type QueryExerciseConnectionArgs = {
  before?: InputMaybe<Scalars['String']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Float']['input']>;
  last?: InputMaybe<Scalars['Float']['input']>;
  sort?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<ExerciseFilter>;
};


export type QueryCourseArgs = {
  relativePath?: InputMaybe<Scalars['String']['input']>;
};


export type QueryCourseConnectionArgs = {
  before?: InputMaybe<Scalars['String']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Float']['input']>;
  last?: InputMaybe<Scalars['Float']['input']>;
  sort?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<CourseFilter>;
};


export type QueryAwfulpracticeArgs = {
  relativePath?: InputMaybe<Scalars['String']['input']>;
};


export type QueryAwfulpracticeConnectionArgs = {
  before?: InputMaybe<Scalars['String']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Float']['input']>;
  last?: InputMaybe<Scalars['Float']['input']>;
  sort?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<AwfulpracticeFilter>;
};


export type QueryRoutinesArgs = {
  relativePath?: InputMaybe<Scalars['String']['input']>;
};


export type QueryRoutinesConnectionArgs = {
  before?: InputMaybe<Scalars['String']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Float']['input']>;
  last?: InputMaybe<Scalars['Float']['input']>;
  sort?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<RoutinesFilter>;
};

export type DocumentFilter = {
  skill?: InputMaybe<SkillFilter>;
  technique?: InputMaybe<TechniqueFilter>;
  art?: InputMaybe<ArtFilter>;
  move?: InputMaybe<MoveFilter>;
  exercise?: InputMaybe<ExerciseFilter>;
  course?: InputMaybe<CourseFilter>;
  awfulpractice?: InputMaybe<AwfulpracticeFilter>;
  routines?: InputMaybe<RoutinesFilter>;
};

export type DocumentConnectionEdges = {
  __typename?: 'DocumentConnectionEdges';
  cursor: Scalars['String']['output'];
  node?: Maybe<DocumentNode>;
};

export type DocumentConnection = Connection & {
  __typename?: 'DocumentConnection';
  pageInfo: PageInfo;
  totalCount: Scalars['Float']['output'];
  edges?: Maybe<Array<Maybe<DocumentConnectionEdges>>>;
};

export type Collection = {
  __typename?: 'Collection';
  name: Scalars['String']['output'];
  slug: Scalars['String']['output'];
  label?: Maybe<Scalars['String']['output']>;
  path: Scalars['String']['output'];
  format?: Maybe<Scalars['String']['output']>;
  matches?: Maybe<Scalars['String']['output']>;
  templates?: Maybe<Array<Maybe<Scalars['JSON']['output']>>>;
  fields?: Maybe<Array<Maybe<Scalars['JSON']['output']>>>;
  documents: DocumentConnection;
};


export type CollectionDocumentsArgs = {
  before?: InputMaybe<Scalars['String']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Float']['input']>;
  last?: InputMaybe<Scalars['Float']['input']>;
  sort?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<DocumentFilter>;
  folder?: InputMaybe<Scalars['String']['input']>;
};

export type DocumentNode = Skill | Technique | Art | Move | Exercise | Course | Awfulpractice | Routines | Folder;

export type Skill = Node & Document & {
  __typename?: 'Skill';
  title: Scalars['String']['output'];
  body?: Maybe<Scalars['JSON']['output']>;
  id: Scalars['ID']['output'];
  _sys: SystemInfo;
  _values: Scalars['JSON']['output'];
};

export type StringFilter = {
  startsWith?: InputMaybe<Scalars['String']['input']>;
  eq?: InputMaybe<Scalars['String']['input']>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type RichTextFilter = {
  startsWith?: InputMaybe<Scalars['String']['input']>;
  eq?: InputMaybe<Scalars['String']['input']>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SkillFilter = {
  title?: InputMaybe<StringFilter>;
  body?: InputMaybe<RichTextFilter>;
};

export type SkillConnectionEdges = {
  __typename?: 'SkillConnectionEdges';
  cursor: Scalars['String']['output'];
  node?: Maybe<Skill>;
};

export type SkillConnection = Connection & {
  __typename?: 'SkillConnection';
  pageInfo: PageInfo;
  totalCount: Scalars['Float']['output'];
  edges?: Maybe<Array<Maybe<SkillConnectionEdges>>>;
};

export type TechniqueArt = Art;

export type TechniqueLinks = {
  __typename?: 'TechniqueLinks';
  label?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export type Technique = Node & Document & {
  __typename?: 'Technique';
  title: Scalars['String']['output'];
  body?: Maybe<Scalars['JSON']['output']>;
  art?: Maybe<TechniqueArt>;
  links?: Maybe<Array<Maybe<TechniqueLinks>>>;
  id: Scalars['ID']['output'];
  _sys: SystemInfo;
  _values: Scalars['JSON']['output'];
};

export type TechniqueArtFilter = {
  art?: InputMaybe<ArtFilter>;
};

export type TechniqueLinksFilter = {
  label?: InputMaybe<StringFilter>;
  url?: InputMaybe<StringFilter>;
};

export type TechniqueFilter = {
  title?: InputMaybe<StringFilter>;
  body?: InputMaybe<RichTextFilter>;
  art?: InputMaybe<TechniqueArtFilter>;
  links?: InputMaybe<TechniqueLinksFilter>;
};

export type TechniqueConnectionEdges = {
  __typename?: 'TechniqueConnectionEdges';
  cursor: Scalars['String']['output'];
  node?: Maybe<Technique>;
};

export type TechniqueConnection = Connection & {
  __typename?: 'TechniqueConnection';
  pageInfo: PageInfo;
  totalCount: Scalars['Float']['output'];
  edges?: Maybe<Array<Maybe<TechniqueConnectionEdges>>>;
};

export type ArtParent = Art;

export type ArtLinks = {
  __typename?: 'ArtLinks';
  label?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export type Art = Node & Document & {
  __typename?: 'Art';
  title: Scalars['String']['output'];
  parent?: Maybe<ArtParent>;
  video?: Maybe<Scalars['String']['output']>;
  links?: Maybe<Array<Maybe<ArtLinks>>>;
  body?: Maybe<Scalars['JSON']['output']>;
  id: Scalars['ID']['output'];
  _sys: SystemInfo;
  _values: Scalars['JSON']['output'];
};

export type ArtParentFilter = {
  art?: InputMaybe<ArtFilter>;
};

export type ArtLinksFilter = {
  label?: InputMaybe<StringFilter>;
  url?: InputMaybe<StringFilter>;
};

export type ArtFilter = {
  title?: InputMaybe<StringFilter>;
  parent?: InputMaybe<ArtParentFilter>;
  video?: InputMaybe<StringFilter>;
  links?: InputMaybe<ArtLinksFilter>;
  body?: InputMaybe<RichTextFilter>;
};

export type ArtConnectionEdges = {
  __typename?: 'ArtConnectionEdges';
  cursor: Scalars['String']['output'];
  node?: Maybe<Art>;
};

export type ArtConnection = Connection & {
  __typename?: 'ArtConnection';
  pageInfo: PageInfo;
  totalCount: Scalars['Float']['output'];
  edges?: Maybe<Array<Maybe<ArtConnectionEdges>>>;
};

export type MoveArt = Art;

export type MoveLinks = {
  __typename?: 'MoveLinks';
  label?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export type MoveMovesData = Move;

export type MoveMoves = {
  __typename?: 'MoveMoves';
  data?: Maybe<MoveMovesData>;
};

export type Move = Node & Document & {
  __typename?: 'Move';
  title: Scalars['String']['output'];
  art?: Maybe<MoveArt>;
  description?: Maybe<Scalars['JSON']['output']>;
  instruction?: Maybe<Scalars['JSON']['output']>;
  video?: Maybe<Scalars['String']['output']>;
  links?: Maybe<Array<Maybe<MoveLinks>>>;
  moves?: Maybe<Array<Maybe<MoveMoves>>>;
  body?: Maybe<Scalars['JSON']['output']>;
  tags?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  id: Scalars['ID']['output'];
  _sys: SystemInfo;
  _values: Scalars['JSON']['output'];
};

export type MoveArtFilter = {
  art?: InputMaybe<ArtFilter>;
};

export type MoveLinksFilter = {
  label?: InputMaybe<StringFilter>;
  url?: InputMaybe<StringFilter>;
};

export type MoveMovesDataFilter = {
  move?: InputMaybe<MoveFilter>;
};

export type MoveMovesFilter = {
  data?: InputMaybe<MoveMovesDataFilter>;
};

export type MoveFilter = {
  title?: InputMaybe<StringFilter>;
  art?: InputMaybe<MoveArtFilter>;
  description?: InputMaybe<RichTextFilter>;
  instruction?: InputMaybe<RichTextFilter>;
  video?: InputMaybe<StringFilter>;
  links?: InputMaybe<MoveLinksFilter>;
  moves?: InputMaybe<MoveMovesFilter>;
  body?: InputMaybe<RichTextFilter>;
  tags?: InputMaybe<StringFilter>;
};

export type MoveConnectionEdges = {
  __typename?: 'MoveConnectionEdges';
  cursor: Scalars['String']['output'];
  node?: Maybe<Move>;
};

export type MoveConnection = Connection & {
  __typename?: 'MoveConnection';
  pageInfo: PageInfo;
  totalCount: Scalars['Float']['output'];
  edges?: Maybe<Array<Maybe<MoveConnectionEdges>>>;
};

export type ExerciseMediaDancemix = {
  __typename?: 'ExerciseMediaDancemix';
  label?: Maybe<Scalars['String']['output']>;
  duration?: Maybe<Scalars['Float']['output']>;
  pause?: Maybe<Scalars['Float']['output']>;
  amount?: Maybe<Scalars['Float']['output']>;
  playlist?: Maybe<Scalars['String']['output']>;
};

export type ExerciseMediaSong = {
  __typename?: 'ExerciseMediaSong';
  id: Scalars['String']['output'];
  play: Scalars['String']['output'];
  start?: Maybe<Scalars['Float']['output']>;
};

export type ExerciseMediaLoop = {
  __typename?: 'ExerciseMediaLoop';
  name?: Maybe<Scalars['String']['output']>;
};

export type ExerciseMediaMaterial = {
  __typename?: 'ExerciseMediaMaterial';
  material?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type ExerciseMedia = ExerciseMediaDancemix | ExerciseMediaSong | ExerciseMediaLoop | ExerciseMediaMaterial;

export type ExerciseInstructionMove = Move;

export type ExerciseInstructionMediaDancemix = {
  __typename?: 'ExerciseInstructionMediaDancemix';
  label?: Maybe<Scalars['String']['output']>;
  duration?: Maybe<Scalars['Float']['output']>;
  pause?: Maybe<Scalars['Float']['output']>;
  amount?: Maybe<Scalars['Float']['output']>;
  playlist?: Maybe<Scalars['String']['output']>;
};

export type ExerciseInstructionMediaSong = {
  __typename?: 'ExerciseInstructionMediaSong';
  id: Scalars['String']['output'];
  play: Scalars['String']['output'];
  start?: Maybe<Scalars['Float']['output']>;
};

export type ExerciseInstructionMediaLoop = {
  __typename?: 'ExerciseInstructionMediaLoop';
  name?: Maybe<Scalars['String']['output']>;
};

export type ExerciseInstructionMediaMaterial = {
  __typename?: 'ExerciseInstructionMediaMaterial';
  material?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type ExerciseInstructionMedia = ExerciseInstructionMediaDancemix | ExerciseInstructionMediaSong | ExerciseInstructionMediaLoop | ExerciseInstructionMediaMaterial;

export type ExerciseInstruction = {
  __typename?: 'ExerciseInstruction';
  title?: Maybe<Scalars['String']['output']>;
  move?: Maybe<ExerciseInstructionMove>;
  duration?: Maybe<Scalars['Float']['output']>;
  content?: Maybe<Scalars['JSON']['output']>;
  method?: Maybe<Scalars['String']['output']>;
  goal?: Maybe<Scalars['String']['output']>;
  media?: Maybe<Array<Maybe<ExerciseInstructionMedia>>>;
};

export type ExerciseExercisesData = Exercise;

export type ExerciseExercises = {
  __typename?: 'ExerciseExercises';
  data?: Maybe<ExerciseExercisesData>;
};

export type ExerciseLinks = {
  __typename?: 'ExerciseLinks';
  label?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export type ExerciseArt = Art;

export type ExerciseTechnique = Technique;

export type ExerciseSkillsData = Skill;

export type ExerciseSkills = {
  __typename?: 'ExerciseSkills';
  data?: Maybe<ExerciseSkillsData>;
};

export type Exercise = Node & Document & {
  __typename?: 'Exercise';
  title: Scalars['String']['output'];
  excerpt?: Maybe<Scalars['String']['output']>;
  body?: Maybe<Scalars['JSON']['output']>;
  media?: Maybe<Array<Maybe<ExerciseMedia>>>;
  instruction?: Maybe<Array<Maybe<ExerciseInstruction>>>;
  difficulty: Scalars['String']['output'];
  locomotion?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  personal?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  tags?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  exercises?: Maybe<Array<Maybe<ExerciseExercises>>>;
  links?: Maybe<Array<Maybe<ExerciseLinks>>>;
  video?: Maybe<Scalars['String']['output']>;
  art?: Maybe<ExerciseArt>;
  technique?: Maybe<ExerciseTechnique>;
  skills?: Maybe<Array<Maybe<ExerciseSkills>>>;
  id: Scalars['ID']['output'];
  _sys: SystemInfo;
  _values: Scalars['JSON']['output'];
};

export type NumberFilter = {
  lt?: InputMaybe<Scalars['Float']['input']>;
  lte?: InputMaybe<Scalars['Float']['input']>;
  gte?: InputMaybe<Scalars['Float']['input']>;
  gt?: InputMaybe<Scalars['Float']['input']>;
  eq?: InputMaybe<Scalars['Float']['input']>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
};

export type ExerciseMediaDancemixFilter = {
  label?: InputMaybe<StringFilter>;
  duration?: InputMaybe<NumberFilter>;
  pause?: InputMaybe<NumberFilter>;
  amount?: InputMaybe<NumberFilter>;
  playlist?: InputMaybe<StringFilter>;
};

export type ExerciseMediaSongFilter = {
  id?: InputMaybe<StringFilter>;
  play?: InputMaybe<StringFilter>;
  start?: InputMaybe<NumberFilter>;
};

export type ExerciseMediaLoopFilter = {
  name?: InputMaybe<StringFilter>;
};

export type ExerciseMediaMaterialFilter = {
  material?: InputMaybe<StringFilter>;
};

export type ExerciseMediaFilter = {
  dancemix?: InputMaybe<ExerciseMediaDancemixFilter>;
  song?: InputMaybe<ExerciseMediaSongFilter>;
  loop?: InputMaybe<ExerciseMediaLoopFilter>;
  material?: InputMaybe<ExerciseMediaMaterialFilter>;
};

export type ExerciseInstructionMoveFilter = {
  move?: InputMaybe<MoveFilter>;
};

export type ExerciseInstructionMediaDancemixFilter = {
  label?: InputMaybe<StringFilter>;
  duration?: InputMaybe<NumberFilter>;
  pause?: InputMaybe<NumberFilter>;
  amount?: InputMaybe<NumberFilter>;
  playlist?: InputMaybe<StringFilter>;
};

export type ExerciseInstructionMediaSongFilter = {
  id?: InputMaybe<StringFilter>;
  play?: InputMaybe<StringFilter>;
  start?: InputMaybe<NumberFilter>;
};

export type ExerciseInstructionMediaLoopFilter = {
  name?: InputMaybe<StringFilter>;
};

export type ExerciseInstructionMediaMaterialFilter = {
  material?: InputMaybe<StringFilter>;
};

export type ExerciseInstructionMediaFilter = {
  dancemix?: InputMaybe<ExerciseInstructionMediaDancemixFilter>;
  song?: InputMaybe<ExerciseInstructionMediaSongFilter>;
  loop?: InputMaybe<ExerciseInstructionMediaLoopFilter>;
  material?: InputMaybe<ExerciseInstructionMediaMaterialFilter>;
};

export type ExerciseInstructionFilter = {
  title?: InputMaybe<StringFilter>;
  move?: InputMaybe<ExerciseInstructionMoveFilter>;
  duration?: InputMaybe<NumberFilter>;
  content?: InputMaybe<RichTextFilter>;
  method?: InputMaybe<StringFilter>;
  goal?: InputMaybe<StringFilter>;
  media?: InputMaybe<ExerciseInstructionMediaFilter>;
};

export type ExerciseExercisesDataFilter = {
  exercise?: InputMaybe<ExerciseFilter>;
};

export type ExerciseExercisesFilter = {
  data?: InputMaybe<ExerciseExercisesDataFilter>;
};

export type ExerciseLinksFilter = {
  label?: InputMaybe<StringFilter>;
  url?: InputMaybe<StringFilter>;
};

export type ExerciseArtFilter = {
  art?: InputMaybe<ArtFilter>;
};

export type ExerciseTechniqueFilter = {
  technique?: InputMaybe<TechniqueFilter>;
};

export type ExerciseSkillsDataFilter = {
  skill?: InputMaybe<SkillFilter>;
};

export type ExerciseSkillsFilter = {
  data?: InputMaybe<ExerciseSkillsDataFilter>;
};

export type ExerciseFilter = {
  title?: InputMaybe<StringFilter>;
  excerpt?: InputMaybe<StringFilter>;
  body?: InputMaybe<RichTextFilter>;
  media?: InputMaybe<ExerciseMediaFilter>;
  instruction?: InputMaybe<ExerciseInstructionFilter>;
  difficulty?: InputMaybe<StringFilter>;
  locomotion?: InputMaybe<StringFilter>;
  personal?: InputMaybe<StringFilter>;
  tags?: InputMaybe<StringFilter>;
  exercises?: InputMaybe<ExerciseExercisesFilter>;
  links?: InputMaybe<ExerciseLinksFilter>;
  video?: InputMaybe<StringFilter>;
  art?: InputMaybe<ExerciseArtFilter>;
  technique?: InputMaybe<ExerciseTechniqueFilter>;
  skills?: InputMaybe<ExerciseSkillsFilter>;
};

export type ExerciseConnectionEdges = {
  __typename?: 'ExerciseConnectionEdges';
  cursor: Scalars['String']['output'];
  node?: Maybe<Exercise>;
};

export type ExerciseConnection = Connection & {
  __typename?: 'ExerciseConnection';
  pageInfo: PageInfo;
  totalCount: Scalars['Float']['output'];
  edges?: Maybe<Array<Maybe<ExerciseConnectionEdges>>>;
};

export type CourseLessonsLessonExercisesData = Exercise;

export type CourseLessonsLessonExercises = {
  __typename?: 'CourseLessonsLessonExercises';
  data?: Maybe<CourseLessonsLessonExercisesData>;
};

export type CourseLessonsLesson = {
  __typename?: 'CourseLessonsLesson';
  title?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  exercises?: Maybe<Array<Maybe<CourseLessonsLessonExercises>>>;
};

export type CourseLessons = CourseLessonsLesson;

export type Course = Node & Document & {
  __typename?: 'Course';
  title: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  about?: Maybe<Scalars['String']['output']>;
  learn?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  examples?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  lessons?: Maybe<Array<Maybe<CourseLessons>>>;
  id: Scalars['ID']['output'];
  _sys: SystemInfo;
  _values: Scalars['JSON']['output'];
};

export type CourseLessonsLessonExercisesDataFilter = {
  exercise?: InputMaybe<ExerciseFilter>;
};

export type CourseLessonsLessonExercisesFilter = {
  data?: InputMaybe<CourseLessonsLessonExercisesDataFilter>;
};

export type CourseLessonsLessonFilter = {
  title?: InputMaybe<StringFilter>;
  description?: InputMaybe<StringFilter>;
  exercises?: InputMaybe<CourseLessonsLessonExercisesFilter>;
};

export type CourseLessonsFilter = {
  lesson?: InputMaybe<CourseLessonsLessonFilter>;
};

export type CourseFilter = {
  title?: InputMaybe<StringFilter>;
  description?: InputMaybe<StringFilter>;
  about?: InputMaybe<StringFilter>;
  learn?: InputMaybe<StringFilter>;
  examples?: InputMaybe<StringFilter>;
  lessons?: InputMaybe<CourseLessonsFilter>;
};

export type CourseConnectionEdges = {
  __typename?: 'CourseConnectionEdges';
  cursor: Scalars['String']['output'];
  node?: Maybe<Course>;
};

export type CourseConnection = Connection & {
  __typename?: 'CourseConnection';
  pageInfo: PageInfo;
  totalCount: Scalars['Float']['output'];
  edges?: Maybe<Array<Maybe<CourseConnectionEdges>>>;
};

export type Awfulpractice = Node & Document & {
  __typename?: 'Awfulpractice';
  title: Scalars['String']['output'];
  tags?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  body?: Maybe<Scalars['JSON']['output']>;
  id: Scalars['ID']['output'];
  _sys: SystemInfo;
  _values: Scalars['JSON']['output'];
};

export type AwfulpracticeFilter = {
  title?: InputMaybe<StringFilter>;
  tags?: InputMaybe<StringFilter>;
  body?: InputMaybe<RichTextFilter>;
};

export type AwfulpracticeConnectionEdges = {
  __typename?: 'AwfulpracticeConnectionEdges';
  cursor: Scalars['String']['output'];
  node?: Maybe<Awfulpractice>;
};

export type AwfulpracticeConnection = Connection & {
  __typename?: 'AwfulpracticeConnection';
  pageInfo: PageInfo;
  totalCount: Scalars['Float']['output'];
  edges?: Maybe<Array<Maybe<AwfulpracticeConnectionEdges>>>;
};

export type RoutinesTimeTrackingScenes = {
  __typename?: 'RoutinesTimeTrackingScenes';
  start?: Maybe<Scalars['Float']['output']>;
  end?: Maybe<Scalars['Float']['output']>;
  category?: Maybe<Scalars['String']['output']>;
};

export type RoutinesTimeTrackingEvaluationArtistry = {
  __typename?: 'RoutinesTimeTrackingEvaluationArtistry';
  duration?: Maybe<Scalars['Float']['output']>;
  ratio?: Maybe<Scalars['Float']['output']>;
};

export type RoutinesTimeTrackingEvaluationCommunication = {
  __typename?: 'RoutinesTimeTrackingEvaluationCommunication';
  duration?: Maybe<Scalars['Float']['output']>;
  ratio?: Maybe<Scalars['Float']['output']>;
};

export type RoutinesTimeTrackingEvaluationTricks = {
  __typename?: 'RoutinesTimeTrackingEvaluationTricks';
  duration?: Maybe<Scalars['Float']['output']>;
  ratio?: Maybe<Scalars['Float']['output']>;
};

export type RoutinesTimeTrackingEvaluationFiller = {
  __typename?: 'RoutinesTimeTrackingEvaluationFiller';
  duration?: Maybe<Scalars['Float']['output']>;
  ratio?: Maybe<Scalars['Float']['output']>;
};

export type RoutinesTimeTrackingEvaluationVoid = {
  __typename?: 'RoutinesTimeTrackingEvaluationVoid';
  duration?: Maybe<Scalars['Float']['output']>;
  ratio?: Maybe<Scalars['Float']['output']>;
};

export type RoutinesTimeTrackingEvaluationDismounts = {
  __typename?: 'RoutinesTimeTrackingEvaluationDismounts';
  duration?: Maybe<Scalars['Float']['output']>;
  ratio?: Maybe<Scalars['Float']['output']>;
};

export type RoutinesTimeTrackingEvaluation = {
  __typename?: 'RoutinesTimeTrackingEvaluation';
  artistry?: Maybe<RoutinesTimeTrackingEvaluationArtistry>;
  communication?: Maybe<RoutinesTimeTrackingEvaluationCommunication>;
  tricks?: Maybe<RoutinesTimeTrackingEvaluationTricks>;
  filler?: Maybe<RoutinesTimeTrackingEvaluationFiller>;
  void?: Maybe<RoutinesTimeTrackingEvaluationVoid>;
  dismounts?: Maybe<RoutinesTimeTrackingEvaluationDismounts>;
};

export type RoutinesTimeTracking = {
  __typename?: 'RoutinesTimeTracking';
  start?: Maybe<Scalars['Float']['output']>;
  end?: Maybe<Scalars['Float']['output']>;
  scenes?: Maybe<Array<Maybe<RoutinesTimeTrackingScenes>>>;
  duration?: Maybe<Scalars['Float']['output']>;
  evaluation?: Maybe<RoutinesTimeTrackingEvaluation>;
};

export type RoutinesArtisticPartsCategoriesCriteria = {
  __typename?: 'RoutinesArtisticPartsCategoriesCriteria';
  name: Scalars['String']['output'];
  value?: Maybe<Scalars['Float']['output']>;
};

export type RoutinesArtisticPartsCategories = {
  __typename?: 'RoutinesArtisticPartsCategories';
  name: Scalars['String']['output'];
  score?: Maybe<Scalars['Float']['output']>;
  criteria?: Maybe<Array<Maybe<RoutinesArtisticPartsCategoriesCriteria>>>;
};

export type RoutinesArtisticParts = {
  __typename?: 'RoutinesArtisticParts';
  name: Scalars['String']['output'];
  score?: Maybe<Scalars['Float']['output']>;
  categories?: Maybe<Array<Maybe<RoutinesArtisticPartsCategories>>>;
};

export type RoutinesArtistic = {
  __typename?: 'RoutinesArtistic';
  name: Scalars['String']['output'];
  score?: Maybe<Scalars['Float']['output']>;
  parts?: Maybe<Array<Maybe<RoutinesArtisticParts>>>;
};

export type Routines = Node & Document & {
  __typename?: 'Routines';
  rider: Scalars['String']['output'];
  type: Scalars['String']['output'];
  event?: Maybe<Scalars['String']['output']>;
  date?: Maybe<Scalars['String']['output']>;
  video: Scalars['String']['output'];
  timeTracking?: Maybe<RoutinesTimeTracking>;
  artistic?: Maybe<RoutinesArtistic>;
  notTodoList?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  id: Scalars['ID']['output'];
  _sys: SystemInfo;
  _values: Scalars['JSON']['output'];
};

export type DatetimeFilter = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  eq?: InputMaybe<Scalars['String']['input']>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type RoutinesTimeTrackingScenesFilter = {
  start?: InputMaybe<NumberFilter>;
  end?: InputMaybe<NumberFilter>;
  category?: InputMaybe<StringFilter>;
};

export type RoutinesTimeTrackingEvaluationArtistryFilter = {
  duration?: InputMaybe<NumberFilter>;
  ratio?: InputMaybe<NumberFilter>;
};

export type RoutinesTimeTrackingEvaluationCommunicationFilter = {
  duration?: InputMaybe<NumberFilter>;
  ratio?: InputMaybe<NumberFilter>;
};

export type RoutinesTimeTrackingEvaluationTricksFilter = {
  duration?: InputMaybe<NumberFilter>;
  ratio?: InputMaybe<NumberFilter>;
};

export type RoutinesTimeTrackingEvaluationFillerFilter = {
  duration?: InputMaybe<NumberFilter>;
  ratio?: InputMaybe<NumberFilter>;
};

export type RoutinesTimeTrackingEvaluationVoidFilter = {
  duration?: InputMaybe<NumberFilter>;
  ratio?: InputMaybe<NumberFilter>;
};

export type RoutinesTimeTrackingEvaluationDismountsFilter = {
  duration?: InputMaybe<NumberFilter>;
  ratio?: InputMaybe<NumberFilter>;
};

export type RoutinesTimeTrackingEvaluationFilter = {
  artistry?: InputMaybe<RoutinesTimeTrackingEvaluationArtistryFilter>;
  communication?: InputMaybe<RoutinesTimeTrackingEvaluationCommunicationFilter>;
  tricks?: InputMaybe<RoutinesTimeTrackingEvaluationTricksFilter>;
  filler?: InputMaybe<RoutinesTimeTrackingEvaluationFillerFilter>;
  void?: InputMaybe<RoutinesTimeTrackingEvaluationVoidFilter>;
  dismounts?: InputMaybe<RoutinesTimeTrackingEvaluationDismountsFilter>;
};

export type RoutinesTimeTrackingFilter = {
  start?: InputMaybe<NumberFilter>;
  end?: InputMaybe<NumberFilter>;
  scenes?: InputMaybe<RoutinesTimeTrackingScenesFilter>;
  duration?: InputMaybe<NumberFilter>;
  evaluation?: InputMaybe<RoutinesTimeTrackingEvaluationFilter>;
};

export type RoutinesArtisticPartsCategoriesCriteriaFilter = {
  name?: InputMaybe<StringFilter>;
  value?: InputMaybe<NumberFilter>;
};

export type RoutinesArtisticPartsCategoriesFilter = {
  name?: InputMaybe<StringFilter>;
  score?: InputMaybe<NumberFilter>;
  criteria?: InputMaybe<RoutinesArtisticPartsCategoriesCriteriaFilter>;
};

export type RoutinesArtisticPartsFilter = {
  name?: InputMaybe<StringFilter>;
  score?: InputMaybe<NumberFilter>;
  categories?: InputMaybe<RoutinesArtisticPartsCategoriesFilter>;
};

export type RoutinesArtisticFilter = {
  name?: InputMaybe<StringFilter>;
  score?: InputMaybe<NumberFilter>;
  parts?: InputMaybe<RoutinesArtisticPartsFilter>;
};

export type RoutinesFilter = {
  rider?: InputMaybe<StringFilter>;
  type?: InputMaybe<StringFilter>;
  event?: InputMaybe<StringFilter>;
  date?: InputMaybe<DatetimeFilter>;
  video?: InputMaybe<StringFilter>;
  timeTracking?: InputMaybe<RoutinesTimeTrackingFilter>;
  artistic?: InputMaybe<RoutinesArtisticFilter>;
  notTodoList?: InputMaybe<StringFilter>;
};

export type RoutinesConnectionEdges = {
  __typename?: 'RoutinesConnectionEdges';
  cursor: Scalars['String']['output'];
  node?: Maybe<Routines>;
};

export type RoutinesConnection = Connection & {
  __typename?: 'RoutinesConnection';
  pageInfo: PageInfo;
  totalCount: Scalars['Float']['output'];
  edges?: Maybe<Array<Maybe<RoutinesConnectionEdges>>>;
};

export type Mutation = {
  __typename?: 'Mutation';
  addPendingDocument: DocumentNode;
  updateDocument: DocumentNode;
  deleteDocument: DocumentNode;
  createDocument: DocumentNode;
  createFolder: DocumentNode;
  updateSkill: Skill;
  createSkill: Skill;
  updateTechnique: Technique;
  createTechnique: Technique;
  updateArt: Art;
  createArt: Art;
  updateMove: Move;
  createMove: Move;
  updateExercise: Exercise;
  createExercise: Exercise;
  updateCourse: Course;
  createCourse: Course;
  updateAwfulpractice: Awfulpractice;
  createAwfulpractice: Awfulpractice;
  updateRoutines: Routines;
  createRoutines: Routines;
};


export type MutationAddPendingDocumentArgs = {
  collection: Scalars['String']['input'];
  relativePath: Scalars['String']['input'];
  template?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUpdateDocumentArgs = {
  collection?: InputMaybe<Scalars['String']['input']>;
  relativePath: Scalars['String']['input'];
  params: DocumentUpdateMutation;
};


export type MutationDeleteDocumentArgs = {
  collection?: InputMaybe<Scalars['String']['input']>;
  relativePath: Scalars['String']['input'];
};


export type MutationCreateDocumentArgs = {
  collection?: InputMaybe<Scalars['String']['input']>;
  relativePath: Scalars['String']['input'];
  params: DocumentMutation;
};


export type MutationCreateFolderArgs = {
  collection?: InputMaybe<Scalars['String']['input']>;
  relativePath: Scalars['String']['input'];
};


export type MutationUpdateSkillArgs = {
  relativePath: Scalars['String']['input'];
  params: SkillMutation;
};


export type MutationCreateSkillArgs = {
  relativePath: Scalars['String']['input'];
  params: SkillMutation;
};


export type MutationUpdateTechniqueArgs = {
  relativePath: Scalars['String']['input'];
  params: TechniqueMutation;
};


export type MutationCreateTechniqueArgs = {
  relativePath: Scalars['String']['input'];
  params: TechniqueMutation;
};


export type MutationUpdateArtArgs = {
  relativePath: Scalars['String']['input'];
  params: ArtMutation;
};


export type MutationCreateArtArgs = {
  relativePath: Scalars['String']['input'];
  params: ArtMutation;
};


export type MutationUpdateMoveArgs = {
  relativePath: Scalars['String']['input'];
  params: MoveMutation;
};


export type MutationCreateMoveArgs = {
  relativePath: Scalars['String']['input'];
  params: MoveMutation;
};


export type MutationUpdateExerciseArgs = {
  relativePath: Scalars['String']['input'];
  params: ExerciseMutation;
};


export type MutationCreateExerciseArgs = {
  relativePath: Scalars['String']['input'];
  params: ExerciseMutation;
};


export type MutationUpdateCourseArgs = {
  relativePath: Scalars['String']['input'];
  params: CourseMutation;
};


export type MutationCreateCourseArgs = {
  relativePath: Scalars['String']['input'];
  params: CourseMutation;
};


export type MutationUpdateAwfulpracticeArgs = {
  relativePath: Scalars['String']['input'];
  params: AwfulpracticeMutation;
};


export type MutationCreateAwfulpracticeArgs = {
  relativePath: Scalars['String']['input'];
  params: AwfulpracticeMutation;
};


export type MutationUpdateRoutinesArgs = {
  relativePath: Scalars['String']['input'];
  params: RoutinesMutation;
};


export type MutationCreateRoutinesArgs = {
  relativePath: Scalars['String']['input'];
  params: RoutinesMutation;
};

export type DocumentUpdateMutation = {
  skill?: InputMaybe<SkillMutation>;
  technique?: InputMaybe<TechniqueMutation>;
  art?: InputMaybe<ArtMutation>;
  move?: InputMaybe<MoveMutation>;
  exercise?: InputMaybe<ExerciseMutation>;
  course?: InputMaybe<CourseMutation>;
  awfulpractice?: InputMaybe<AwfulpracticeMutation>;
  routines?: InputMaybe<RoutinesMutation>;
  relativePath?: InputMaybe<Scalars['String']['input']>;
};

export type DocumentMutation = {
  skill?: InputMaybe<SkillMutation>;
  technique?: InputMaybe<TechniqueMutation>;
  art?: InputMaybe<ArtMutation>;
  move?: InputMaybe<MoveMutation>;
  exercise?: InputMaybe<ExerciseMutation>;
  course?: InputMaybe<CourseMutation>;
  awfulpractice?: InputMaybe<AwfulpracticeMutation>;
  routines?: InputMaybe<RoutinesMutation>;
};

export type SkillMutation = {
  title?: InputMaybe<Scalars['String']['input']>;
  body?: InputMaybe<Scalars['JSON']['input']>;
};

export type TechniqueLinksMutation = {
  label?: InputMaybe<Scalars['String']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};

export type TechniqueMutation = {
  title?: InputMaybe<Scalars['String']['input']>;
  body?: InputMaybe<Scalars['JSON']['input']>;
  art?: InputMaybe<Scalars['String']['input']>;
  links?: InputMaybe<Array<InputMaybe<TechniqueLinksMutation>>>;
};

export type ArtLinksMutation = {
  label?: InputMaybe<Scalars['String']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};

export type ArtMutation = {
  title?: InputMaybe<Scalars['String']['input']>;
  parent?: InputMaybe<Scalars['String']['input']>;
  video?: InputMaybe<Scalars['String']['input']>;
  links?: InputMaybe<Array<InputMaybe<ArtLinksMutation>>>;
  body?: InputMaybe<Scalars['JSON']['input']>;
};

export type MoveLinksMutation = {
  label?: InputMaybe<Scalars['String']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};

export type MoveMovesMutation = {
  data?: InputMaybe<Scalars['String']['input']>;
};

export type MoveMutation = {
  title?: InputMaybe<Scalars['String']['input']>;
  art?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['JSON']['input']>;
  instruction?: InputMaybe<Scalars['JSON']['input']>;
  video?: InputMaybe<Scalars['String']['input']>;
  links?: InputMaybe<Array<InputMaybe<MoveLinksMutation>>>;
  moves?: InputMaybe<Array<InputMaybe<MoveMovesMutation>>>;
  body?: InputMaybe<Scalars['JSON']['input']>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ExerciseMediaDancemixMutation = {
  label?: InputMaybe<Scalars['String']['input']>;
  duration?: InputMaybe<Scalars['Float']['input']>;
  pause?: InputMaybe<Scalars['Float']['input']>;
  amount?: InputMaybe<Scalars['Float']['input']>;
  playlist?: InputMaybe<Scalars['String']['input']>;
};

export type ExerciseMediaSongMutation = {
  id?: InputMaybe<Scalars['String']['input']>;
  play?: InputMaybe<Scalars['String']['input']>;
  start?: InputMaybe<Scalars['Float']['input']>;
};

export type ExerciseMediaLoopMutation = {
  name?: InputMaybe<Scalars['String']['input']>;
};

export type ExerciseMediaMaterialMutation = {
  material?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ExerciseMediaMutation = {
  dancemix?: InputMaybe<ExerciseMediaDancemixMutation>;
  song?: InputMaybe<ExerciseMediaSongMutation>;
  loop?: InputMaybe<ExerciseMediaLoopMutation>;
  material?: InputMaybe<ExerciseMediaMaterialMutation>;
};

export type ExerciseInstructionMediaDancemixMutation = {
  label?: InputMaybe<Scalars['String']['input']>;
  duration?: InputMaybe<Scalars['Float']['input']>;
  pause?: InputMaybe<Scalars['Float']['input']>;
  amount?: InputMaybe<Scalars['Float']['input']>;
  playlist?: InputMaybe<Scalars['String']['input']>;
};

export type ExerciseInstructionMediaSongMutation = {
  id?: InputMaybe<Scalars['String']['input']>;
  play?: InputMaybe<Scalars['String']['input']>;
  start?: InputMaybe<Scalars['Float']['input']>;
};

export type ExerciseInstructionMediaLoopMutation = {
  name?: InputMaybe<Scalars['String']['input']>;
};

export type ExerciseInstructionMediaMaterialMutation = {
  material?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ExerciseInstructionMediaMutation = {
  dancemix?: InputMaybe<ExerciseInstructionMediaDancemixMutation>;
  song?: InputMaybe<ExerciseInstructionMediaSongMutation>;
  loop?: InputMaybe<ExerciseInstructionMediaLoopMutation>;
  material?: InputMaybe<ExerciseInstructionMediaMaterialMutation>;
};

export type ExerciseInstructionMutation = {
  title?: InputMaybe<Scalars['String']['input']>;
  move?: InputMaybe<Scalars['String']['input']>;
  duration?: InputMaybe<Scalars['Float']['input']>;
  content?: InputMaybe<Scalars['JSON']['input']>;
  method?: InputMaybe<Scalars['String']['input']>;
  goal?: InputMaybe<Scalars['String']['input']>;
  media?: InputMaybe<Array<InputMaybe<ExerciseInstructionMediaMutation>>>;
};

export type ExerciseExercisesMutation = {
  data?: InputMaybe<Scalars['String']['input']>;
};

export type ExerciseLinksMutation = {
  label?: InputMaybe<Scalars['String']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};

export type ExerciseSkillsMutation = {
  data?: InputMaybe<Scalars['String']['input']>;
};

export type ExerciseMutation = {
  title?: InputMaybe<Scalars['String']['input']>;
  excerpt?: InputMaybe<Scalars['String']['input']>;
  body?: InputMaybe<Scalars['JSON']['input']>;
  media?: InputMaybe<Array<InputMaybe<ExerciseMediaMutation>>>;
  instruction?: InputMaybe<Array<InputMaybe<ExerciseInstructionMutation>>>;
  difficulty?: InputMaybe<Scalars['String']['input']>;
  locomotion?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  personal?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  exercises?: InputMaybe<Array<InputMaybe<ExerciseExercisesMutation>>>;
  links?: InputMaybe<Array<InputMaybe<ExerciseLinksMutation>>>;
  video?: InputMaybe<Scalars['String']['input']>;
  art?: InputMaybe<Scalars['String']['input']>;
  technique?: InputMaybe<Scalars['String']['input']>;
  skills?: InputMaybe<Array<InputMaybe<ExerciseSkillsMutation>>>;
};

export type CourseLessonsLessonExercisesMutation = {
  data?: InputMaybe<Scalars['String']['input']>;
};

export type CourseLessonsLessonMutation = {
  title?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  exercises?: InputMaybe<Array<InputMaybe<CourseLessonsLessonExercisesMutation>>>;
};

export type CourseLessonsMutation = {
  lesson?: InputMaybe<CourseLessonsLessonMutation>;
};

export type CourseMutation = {
  title?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  about?: InputMaybe<Scalars['String']['input']>;
  learn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  examples?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lessons?: InputMaybe<Array<InputMaybe<CourseLessonsMutation>>>;
};

export type AwfulpracticeMutation = {
  title?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  body?: InputMaybe<Scalars['JSON']['input']>;
};

export type RoutinesTimeTrackingScenesMutation = {
  start?: InputMaybe<Scalars['Float']['input']>;
  end?: InputMaybe<Scalars['Float']['input']>;
  category?: InputMaybe<Scalars['String']['input']>;
};

export type RoutinesTimeTrackingEvaluationArtistryMutation = {
  duration?: InputMaybe<Scalars['Float']['input']>;
  ratio?: InputMaybe<Scalars['Float']['input']>;
};

export type RoutinesTimeTrackingEvaluationCommunicationMutation = {
  duration?: InputMaybe<Scalars['Float']['input']>;
  ratio?: InputMaybe<Scalars['Float']['input']>;
};

export type RoutinesTimeTrackingEvaluationTricksMutation = {
  duration?: InputMaybe<Scalars['Float']['input']>;
  ratio?: InputMaybe<Scalars['Float']['input']>;
};

export type RoutinesTimeTrackingEvaluationFillerMutation = {
  duration?: InputMaybe<Scalars['Float']['input']>;
  ratio?: InputMaybe<Scalars['Float']['input']>;
};

export type RoutinesTimeTrackingEvaluationVoidMutation = {
  duration?: InputMaybe<Scalars['Float']['input']>;
  ratio?: InputMaybe<Scalars['Float']['input']>;
};

export type RoutinesTimeTrackingEvaluationDismountsMutation = {
  duration?: InputMaybe<Scalars['Float']['input']>;
  ratio?: InputMaybe<Scalars['Float']['input']>;
};

export type RoutinesTimeTrackingEvaluationMutation = {
  artistry?: InputMaybe<RoutinesTimeTrackingEvaluationArtistryMutation>;
  communication?: InputMaybe<RoutinesTimeTrackingEvaluationCommunicationMutation>;
  tricks?: InputMaybe<RoutinesTimeTrackingEvaluationTricksMutation>;
  filler?: InputMaybe<RoutinesTimeTrackingEvaluationFillerMutation>;
  void?: InputMaybe<RoutinesTimeTrackingEvaluationVoidMutation>;
  dismounts?: InputMaybe<RoutinesTimeTrackingEvaluationDismountsMutation>;
};

export type RoutinesTimeTrackingMutation = {
  start?: InputMaybe<Scalars['Float']['input']>;
  end?: InputMaybe<Scalars['Float']['input']>;
  scenes?: InputMaybe<Array<InputMaybe<RoutinesTimeTrackingScenesMutation>>>;
  duration?: InputMaybe<Scalars['Float']['input']>;
  evaluation?: InputMaybe<RoutinesTimeTrackingEvaluationMutation>;
};

export type RoutinesArtisticPartsCategoriesCriteriaMutation = {
  name?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['Float']['input']>;
};

export type RoutinesArtisticPartsCategoriesMutation = {
  name?: InputMaybe<Scalars['String']['input']>;
  score?: InputMaybe<Scalars['Float']['input']>;
  criteria?: InputMaybe<Array<InputMaybe<RoutinesArtisticPartsCategoriesCriteriaMutation>>>;
};

export type RoutinesArtisticPartsMutation = {
  name?: InputMaybe<Scalars['String']['input']>;
  score?: InputMaybe<Scalars['Float']['input']>;
  categories?: InputMaybe<Array<InputMaybe<RoutinesArtisticPartsCategoriesMutation>>>;
};

export type RoutinesArtisticMutation = {
  name?: InputMaybe<Scalars['String']['input']>;
  score?: InputMaybe<Scalars['Float']['input']>;
  parts?: InputMaybe<Array<InputMaybe<RoutinesArtisticPartsMutation>>>;
};

export type RoutinesMutation = {
  rider?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  event?: InputMaybe<Scalars['String']['input']>;
  date?: InputMaybe<Scalars['String']['input']>;
  video?: InputMaybe<Scalars['String']['input']>;
  timeTracking?: InputMaybe<RoutinesTimeTrackingMutation>;
  artistic?: InputMaybe<RoutinesArtisticMutation>;
  notTodoList?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type SkillPartsFragment = { __typename: 'Skill', title: string, body?: any | null };

export type TechniquePartsFragment = { __typename: 'Technique', title: string, body?: any | null, art?: { __typename: 'Art', title: string, video?: string | null, body?: any | null, id: string, parent?: { __typename: 'Art', title: string, video?: string | null, body?: any | null, id: string, links?: Array<{ __typename: 'ArtLinks', label?: string | null, url?: string | null } | null> | null, _sys: { __typename?: 'SystemInfo', filename: string, basename: string, breadcrumbs: Array<string>, path: string, relativePath: string, extension: string } } | null, links?: Array<{ __typename: 'ArtLinks', label?: string | null, url?: string | null } | null> | null, _sys: { __typename?: 'SystemInfo', filename: string, basename: string, breadcrumbs: Array<string>, path: string, relativePath: string, extension: string } } | null, links?: Array<{ __typename: 'TechniqueLinks', label?: string | null, url?: string | null } | null> | null };

export type ArtPartsFragment = { __typename: 'Art', title: string, video?: string | null, body?: any | null, parent?: { __typename: 'Art', title: string, video?: string | null, body?: any | null, id: string, parent?: { __typename: 'Art', title: string, video?: string | null, body?: any | null, id: string, links?: Array<{ __typename: 'ArtLinks', label?: string | null, url?: string | null } | null> | null, _sys: { __typename?: 'SystemInfo', filename: string, basename: string, breadcrumbs: Array<string>, path: string, relativePath: string, extension: string } } | null, links?: Array<{ __typename: 'ArtLinks', label?: string | null, url?: string | null } | null> | null, _sys: { __typename?: 'SystemInfo', filename: string, basename: string, breadcrumbs: Array<string>, path: string, relativePath: string, extension: string } } | null, links?: Array<{ __typename: 'ArtLinks', label?: string | null, url?: string | null } | null> | null };

export type MovePartsFragment = { __typename: 'Move', title: string, description?: any | null, instruction?: any | null, video?: string | null, body?: any | null, tags?: Array<string | null> | null, art?: { __typename: 'Art', title: string, video?: string | null, body?: any | null, id: string, parent?: { __typename: 'Art', title: string, video?: string | null, body?: any | null, id: string, links?: Array<{ __typename: 'ArtLinks', label?: string | null, url?: string | null } | null> | null, _sys: { __typename?: 'SystemInfo', filename: string, basename: string, breadcrumbs: Array<string>, path: string, relativePath: string, extension: string } } | null, links?: Array<{ __typename: 'ArtLinks', label?: string | null, url?: string | null } | null> | null, _sys: { __typename?: 'SystemInfo', filename: string, basename: string, breadcrumbs: Array<string>, path: string, relativePath: string, extension: string } } | null, links?: Array<{ __typename: 'MoveLinks', label?: string | null, url?: string | null } | null> | null, moves?: Array<{ __typename: 'MoveMoves', data?: { __typename: 'Move', title: string, description?: any | null, instruction?: any | null, video?: string | null, body?: any | null, tags?: Array<string | null> | null, id: string, art?: { __typename: 'Art', title: string, video?: string | null, body?: any | null, id: string, links?: Array<{ __typename: 'ArtLinks', label?: string | null, url?: string | null } | null> | null, _sys: { __typename?: 'SystemInfo', filename: string, basename: string, breadcrumbs: Array<string>, path: string, relativePath: string, extension: string } } | null, links?: Array<{ __typename: 'MoveLinks', label?: string | null, url?: string | null } | null> | null, moves?: Array<{ __typename: 'MoveMoves', data?: { __typename: 'Move', title: string, description?: any | null, instruction?: any | null, video?: string | null, body?: any | null, tags?: Array<string | null> | null, id: string, links?: Array<{ __typename: 'MoveLinks', label?: string | null, url?: string | null } | null> | null, moves?: Array<{ __typename: 'MoveMoves' } | null> | null, _sys: { __typename?: 'SystemInfo', filename: string, basename: string, breadcrumbs: Array<string>, path: string, relativePath: string, extension: string } } | null } | null> | null, _sys: { __typename?: 'SystemInfo', filename: string, basename: string, breadcrumbs: Array<string>, path: string, relativePath: string, extension: string } } | null } | null> | null };

export type ExercisePartsFragment = { __typename: 'Exercise', title: string, excerpt?: string | null, body?: any | null, difficulty: string, locomotion?: Array<string | null> | null, personal?: Array<string | null> | null, tags?: Array<string | null> | null, video?: string | null, media?: Array<{ __typename: 'ExerciseMediaDancemix', label?: string | null, duration?: number | null, pause?: number | null, amount?: number | null, playlist?: string | null } | { __typename: 'ExerciseMediaSong', id: string, play: string, start?: number | null } | { __typename: 'ExerciseMediaLoop', name?: string | null } | { __typename: 'ExerciseMediaMaterial', material?: Array<string | null> | null } | null> | null, instruction?: Array<{ __typename: 'ExerciseInstruction', title?: string | null, duration?: number | null, content?: any | null, method?: string | null, goal?: string | null, move?: { __typename: 'Move', title: string, description?: any | null, instruction?: any | null, video?: string | null, body?: any | null, tags?: Array<string | null> | null, id: string, art?: { __typename: 'Art', title: string, video?: string | null, body?: any | null, id: string, links?: Array<{ __typename: 'ArtLinks', label?: string | null, url?: string | null } | null> | null, _sys: { __typename?: 'SystemInfo', filename: string, basename: string, breadcrumbs: Array<string>, path: string, relativePath: string, extension: string } } | null, links?: Array<{ __typename: 'MoveLinks', label?: string | null, url?: string | null } | null> | null, moves?: Array<{ __typename: 'MoveMoves', data?: { __typename: 'Move', title: string, description?: any | null, instruction?: any | null, video?: string | null, body?: any | null, tags?: Array<string | null> | null, id: string, links?: Array<{ __typename: 'MoveLinks', label?: string | null, url?: string | null } | null> | null, moves?: Array<{ __typename: 'MoveMoves' } | null> | null, _sys: { __typename?: 'SystemInfo', filename: string, basename: string, breadcrumbs: Array<string>, path: string, relativePath: string, extension: string } } | null } | null> | null, _sys: { __typename?: 'SystemInfo', filename: string, basename: string, breadcrumbs: Array<string>, path: string, relativePath: string, extension: string } } | null, media?: Array<{ __typename: 'ExerciseInstructionMediaDancemix', label?: string | null, duration?: number | null, pause?: number | null, amount?: number | null, playlist?: string | null } | { __typename: 'ExerciseInstructionMediaSong', id: string, play: string, start?: number | null } | { __typename: 'ExerciseInstructionMediaLoop', name?: string | null } | { __typename: 'ExerciseInstructionMediaMaterial', material?: Array<string | null> | null } | null> | null } | null> | null, exercises?: Array<{ __typename: 'ExerciseExercises', data?: { __typename: 'Exercise', title: string, excerpt?: string | null, body?: any | null, difficulty: string, locomotion?: Array<string | null> | null, personal?: Array<string | null> | null, tags?: Array<string | null> | null, video?: string | null, id: string, media?: Array<{ __typename: 'ExerciseMediaDancemix', label?: string | null, duration?: number | null, pause?: number | null, amount?: number | null, playlist?: string | null } | { __typename: 'ExerciseMediaSong', id: string, play: string, start?: number | null } | { __typename: 'ExerciseMediaLoop', name?: string | null } | { __typename: 'ExerciseMediaMaterial', material?: Array<string | null> | null } | null> | null, instruction?: Array<{ __typename: 'ExerciseInstruction', title?: string | null, duration?: number | null, content?: any | null, method?: string | null, goal?: string | null, move?: { __typename: 'Move', title: string, description?: any | null, instruction?: any | null, video?: string | null, body?: any | null, tags?: Array<string | null> | null, id: string, links?: Array<{ __typename: 'MoveLinks', label?: string | null, url?: string | null } | null> | null, moves?: Array<{ __typename: 'MoveMoves' } | null> | null, _sys: { __typename?: 'SystemInfo', filename: string, basename: string, breadcrumbs: Array<string>, path: string, relativePath: string, extension: string } } | null, media?: Array<{ __typename: 'ExerciseInstructionMediaDancemix', label?: string | null, duration?: number | null, pause?: number | null, amount?: number | null, playlist?: string | null } | { __typename: 'ExerciseInstructionMediaSong', id: string, play: string, start?: number | null } | { __typename: 'ExerciseInstructionMediaLoop', name?: string | null } | { __typename: 'ExerciseInstructionMediaMaterial', material?: Array<string | null> | null } | null> | null } | null> | null, exercises?: Array<{ __typename: 'ExerciseExercises', data?: { __typename: 'Exercise', title: string, excerpt?: string | null, body?: any | null, difficulty: string, locomotion?: Array<string | null> | null, personal?: Array<string | null> | null, tags?: Array<string | null> | null, video?: string | null, id: string, media?: Array<{ __typename: 'ExerciseMediaDancemix', label?: string | null, duration?: number | null, pause?: number | null, amount?: number | null, playlist?: string | null } | { __typename: 'ExerciseMediaSong', id: string, play: string, start?: number | null } | { __typename: 'ExerciseMediaLoop', name?: string | null } | { __typename: 'ExerciseMediaMaterial', material?: Array<string | null> | null } | null> | null, instruction?: Array<{ __typename: 'ExerciseInstruction', title?: string | null, duration?: number | null, content?: any | null, method?: string | null, goal?: string | null, media?: Array<{ __typename: 'ExerciseInstructionMediaDancemix', label?: string | null, duration?: number | null, pause?: number | null, amount?: number | null, playlist?: string | null } | { __typename: 'ExerciseInstructionMediaSong', id: string, play: string, start?: number | null } | { __typename: 'ExerciseInstructionMediaLoop', name?: string | null } | { __typename: 'ExerciseInstructionMediaMaterial', material?: Array<string | null> | null } | null> | null } | null> | null, exercises?: Array<{ __typename: 'ExerciseExercises' } | null> | null, links?: Array<{ __typename: 'ExerciseLinks', label?: string | null, url?: string | null } | null> | null, skills?: Array<{ __typename: 'ExerciseSkills' } | null> | null, _sys: { __typename?: 'SystemInfo', filename: string, basename: string, breadcrumbs: Array<string>, path: string, relativePath: string, extension: string } } | null } | null> | null, links?: Array<{ __typename: 'ExerciseLinks', label?: string | null, url?: string | null } | null> | null, art?: { __typename: 'Art', title: string, video?: string | null, body?: any | null, id: string, links?: Array<{ __typename: 'ArtLinks', label?: string | null, url?: string | null } | null> | null, _sys: { __typename?: 'SystemInfo', filename: string, basename: string, breadcrumbs: Array<string>, path: string, relativePath: string, extension: string } } | null, technique?: { __typename: 'Technique', title: string, body?: any | null, id: string, links?: Array<{ __typename: 'TechniqueLinks', label?: string | null, url?: string | null } | null> | null, _sys: { __typename?: 'SystemInfo', filename: string, basename: string, breadcrumbs: Array<string>, path: string, relativePath: string, extension: string } } | null, skills?: Array<{ __typename: 'ExerciseSkills', data?: { __typename: 'Skill', title: string, body?: any | null, id: string, _sys: { __typename?: 'SystemInfo', filename: string, basename: string, breadcrumbs: Array<string>, path: string, relativePath: string, extension: string } } | null } | null> | null, _sys: { __typename?: 'SystemInfo', filename: string, basename: string, breadcrumbs: Array<string>, path: string, relativePath: string, extension: string } } | null } | null> | null, links?: Array<{ __typename: 'ExerciseLinks', label?: string | null, url?: string | null } | null> | null, art?: { __typename: 'Art', title: string, video?: string | null, body?: any | null, id: string, parent?: { __typename: 'Art', title: string, video?: string | null, body?: any | null, id: string, links?: Array<{ __typename: 'ArtLinks', label?: string | null, url?: string | null } | null> | null, _sys: { __typename?: 'SystemInfo', filename: string, basename: string, breadcrumbs: Array<string>, path: string, relativePath: string, extension: string } } | null, links?: Array<{ __typename: 'ArtLinks', label?: string | null, url?: string | null } | null> | null, _sys: { __typename?: 'SystemInfo', filename: string, basename: string, breadcrumbs: Array<string>, path: string, relativePath: string, extension: string } } | null, technique?: { __typename: 'Technique', title: string, body?: any | null, id: string, art?: { __typename: 'Art', title: string, video?: string | null, body?: any | null, id: string, links?: Array<{ __typename: 'ArtLinks', label?: string | null, url?: string | null } | null> | null, _sys: { __typename?: 'SystemInfo', filename: string, basename: string, breadcrumbs: Array<string>, path: string, relativePath: string, extension: string } } | null, links?: Array<{ __typename: 'TechniqueLinks', label?: string | null, url?: string | null } | null> | null, _sys: { __typename?: 'SystemInfo', filename: string, basename: string, breadcrumbs: Array<string>, path: string, relativePath: string, extension: string } } | null, skills?: Array<{ __typename: 'ExerciseSkills', data?: { __typename: 'Skill', title: string, body?: any | null, id: string, _sys: { __typename?: 'SystemInfo', filename: string, basename: string, breadcrumbs: Array<string>, path: string, relativePath: string, extension: string } } | null } | null> | null };

export type CoursePartsFragment = { __typename: 'Course', title: string, description?: string | null, about?: string | null, learn?: Array<string | null> | null, examples?: Array<string | null> | null, lessons?: Array<{ __typename: 'CourseLessonsLesson', title?: string | null, description?: string | null, exercises?: Array<{ __typename: 'CourseLessonsLessonExercises', data?: { __typename: 'Exercise', title: string, excerpt?: string | null, body?: any | null, difficulty: string, locomotion?: Array<string | null> | null, personal?: Array<string | null> | null, tags?: Array<string | null> | null, video?: string | null, id: string, media?: Array<{ __typename: 'ExerciseMediaDancemix', label?: string | null, duration?: number | null, pause?: number | null, amount?: number | null, playlist?: string | null } | { __typename: 'ExerciseMediaSong', id: string, play: string, start?: number | null } | { __typename: 'ExerciseMediaLoop', name?: string | null } | { __typename: 'ExerciseMediaMaterial', material?: Array<string | null> | null } | null> | null, instruction?: Array<{ __typename: 'ExerciseInstruction', title?: string | null, duration?: number | null, content?: any | null, method?: string | null, goal?: string | null, move?: { __typename: 'Move', title: string, description?: any | null, instruction?: any | null, video?: string | null, body?: any | null, tags?: Array<string | null> | null, id: string, links?: Array<{ __typename: 'MoveLinks', label?: string | null, url?: string | null } | null> | null, moves?: Array<{ __typename: 'MoveMoves' } | null> | null, _sys: { __typename?: 'SystemInfo', filename: string, basename: string, breadcrumbs: Array<string>, path: string, relativePath: string, extension: string } } | null, media?: Array<{ __typename: 'ExerciseInstructionMediaDancemix', label?: string | null, duration?: number | null, pause?: number | null, amount?: number | null, playlist?: string | null } | { __typename: 'ExerciseInstructionMediaSong', id: string, play: string, start?: number | null } | { __typename: 'ExerciseInstructionMediaLoop', name?: string | null } | { __typename: 'ExerciseInstructionMediaMaterial', material?: Array<string | null> | null } | null> | null } | null> | null, exercises?: Array<{ __typename: 'ExerciseExercises', data?: { __typename: 'Exercise', title: string, excerpt?: string | null, body?: any | null, difficulty: string, locomotion?: Array<string | null> | null, personal?: Array<string | null> | null, tags?: Array<string | null> | null, video?: string | null, id: string, media?: Array<{ __typename: 'ExerciseMediaDancemix', label?: string | null, duration?: number | null, pause?: number | null, amount?: number | null, playlist?: string | null } | { __typename: 'ExerciseMediaSong', id: string, play: string, start?: number | null } | { __typename: 'ExerciseMediaLoop', name?: string | null } | { __typename: 'ExerciseMediaMaterial', material?: Array<string | null> | null } | null> | null, instruction?: Array<{ __typename: 'ExerciseInstruction', title?: string | null, duration?: number | null, content?: any | null, method?: string | null, goal?: string | null, media?: Array<{ __typename: 'ExerciseInstructionMediaDancemix', label?: string | null, duration?: number | null, pause?: number | null, amount?: number | null, playlist?: string | null } | { __typename: 'ExerciseInstructionMediaSong', id: string, play: string, start?: number | null } | { __typename: 'ExerciseInstructionMediaLoop', name?: string | null } | { __typename: 'ExerciseInstructionMediaMaterial', material?: Array<string | null> | null } | null> | null } | null> | null, exercises?: Array<{ __typename: 'ExerciseExercises' } | null> | null, links?: Array<{ __typename: 'ExerciseLinks', label?: string | null, url?: string | null } | null> | null, skills?: Array<{ __typename: 'ExerciseSkills' } | null> | null, _sys: { __typename?: 'SystemInfo', filename: string, basename: string, breadcrumbs: Array<string>, path: string, relativePath: string, extension: string } } | null } | null> | null, links?: Array<{ __typename: 'ExerciseLinks', label?: string | null, url?: string | null } | null> | null, art?: { __typename: 'Art', title: string, video?: string | null, body?: any | null, id: string, links?: Array<{ __typename: 'ArtLinks', label?: string | null, url?: string | null } | null> | null, _sys: { __typename?: 'SystemInfo', filename: string, basename: string, breadcrumbs: Array<string>, path: string, relativePath: string, extension: string } } | null, technique?: { __typename: 'Technique', title: string, body?: any | null, id: string, links?: Array<{ __typename: 'TechniqueLinks', label?: string | null, url?: string | null } | null> | null, _sys: { __typename?: 'SystemInfo', filename: string, basename: string, breadcrumbs: Array<string>, path: string, relativePath: string, extension: string } } | null, skills?: Array<{ __typename: 'ExerciseSkills', data?: { __typename: 'Skill', title: string, body?: any | null, id: string, _sys: { __typename?: 'SystemInfo', filename: string, basename: string, breadcrumbs: Array<string>, path: string, relativePath: string, extension: string } } | null } | null> | null, _sys: { __typename?: 'SystemInfo', filename: string, basename: string, breadcrumbs: Array<string>, path: string, relativePath: string, extension: string } } | null } | null> | null } | null> | null };

export type AwfulpracticePartsFragment = { __typename: 'Awfulpractice', title: string, tags?: Array<string | null> | null, body?: any | null };

export type RoutinesPartsFragment = { __typename: 'Routines', rider: string, type: string, event?: string | null, date?: string | null, video: string, notTodoList?: Array<string | null> | null, timeTracking?: { __typename: 'RoutinesTimeTracking', start?: number | null, end?: number | null, duration?: number | null, scenes?: Array<{ __typename: 'RoutinesTimeTrackingScenes', start?: number | null, end?: number | null, category?: string | null } | null> | null, evaluation?: { __typename: 'RoutinesTimeTrackingEvaluation', artistry?: { __typename: 'RoutinesTimeTrackingEvaluationArtistry', duration?: number | null, ratio?: number | null } | null, communication?: { __typename: 'RoutinesTimeTrackingEvaluationCommunication', duration?: number | null, ratio?: number | null } | null, tricks?: { __typename: 'RoutinesTimeTrackingEvaluationTricks', duration?: number | null, ratio?: number | null } | null, filler?: { __typename: 'RoutinesTimeTrackingEvaluationFiller', duration?: number | null, ratio?: number | null } | null, void?: { __typename: 'RoutinesTimeTrackingEvaluationVoid', duration?: number | null, ratio?: number | null } | null, dismounts?: { __typename: 'RoutinesTimeTrackingEvaluationDismounts', duration?: number | null, ratio?: number | null } | null } | null } | null, artistic?: { __typename: 'RoutinesArtistic', name: string, score?: number | null, parts?: Array<{ __typename: 'RoutinesArtisticParts', name: string, score?: number | null, categories?: Array<{ __typename: 'RoutinesArtisticPartsCategories', name: string, score?: number | null, criteria?: Array<{ __typename: 'RoutinesArtisticPartsCategoriesCriteria', name: string, value?: number | null } | null> | null } | null> | null } | null> | null } | null };

export type SkillQueryVariables = Exact<{
  relativePath: Scalars['String']['input'];
}>;


export type SkillQuery = { __typename?: 'Query', skill: { __typename: 'Skill', id: string, title: string, body?: any | null, _sys: { __typename?: 'SystemInfo', filename: string, basename: string, breadcrumbs: Array<string>, path: string, relativePath: string, extension: string } } };

export type SkillConnectionQueryVariables = Exact<{
  before?: InputMaybe<Scalars['String']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Float']['input']>;
  last?: InputMaybe<Scalars['Float']['input']>;
  sort?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<SkillFilter>;
}>;


export type SkillConnectionQuery = { __typename?: 'Query', skillConnection: { __typename?: 'SkillConnection', totalCount: number, pageInfo: { __typename?: 'PageInfo', hasPreviousPage: boolean, hasNextPage: boolean, startCursor: string, endCursor: string }, edges?: Array<{ __typename?: 'SkillConnectionEdges', cursor: string, node?: { __typename: 'Skill', id: string, title: string, body?: any | null, _sys: { __typename?: 'SystemInfo', filename: string, basename: string, breadcrumbs: Array<string>, path: string, relativePath: string, extension: string } } | null } | null> | null } };

export type TechniqueQueryVariables = Exact<{
  relativePath: Scalars['String']['input'];
}>;


export type TechniqueQuery = { __typename?: 'Query', technique: { __typename: 'Technique', id: string, title: string, body?: any | null, _sys: { __typename?: 'SystemInfo', filename: string, basename: string, breadcrumbs: Array<string>, path: string, relativePath: string, extension: string }, art?: { __typename: 'Art', title: string, video?: string | null, body?: any | null, id: string, parent?: { __typename: 'Art', title: string, video?: string | null, body?: any | null, id: string, links?: Array<{ __typename: 'ArtLinks', label?: string | null, url?: string | null } | null> | null, _sys: { __typename?: 'SystemInfo', filename: string, basename: string, breadcrumbs: Array<string>, path: string, relativePath: string, extension: string } } | null, links?: Array<{ __typename: 'ArtLinks', label?: string | null, url?: string | null } | null> | null, _sys: { __typename?: 'SystemInfo', filename: string, basename: string, breadcrumbs: Array<string>, path: string, relativePath: string, extension: string } } | null, links?: Array<{ __typename: 'TechniqueLinks', label?: string | null, url?: string | null } | null> | null } };

export type TechniqueConnectionQueryVariables = Exact<{
  before?: InputMaybe<Scalars['String']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Float']['input']>;
  last?: InputMaybe<Scalars['Float']['input']>;
  sort?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<TechniqueFilter>;
}>;


export type TechniqueConnectionQuery = { __typename?: 'Query', techniqueConnection: { __typename?: 'TechniqueConnection', totalCount: number, pageInfo: { __typename?: 'PageInfo', hasPreviousPage: boolean, hasNextPage: boolean, startCursor: string, endCursor: string }, edges?: Array<{ __typename?: 'TechniqueConnectionEdges', cursor: string, node?: { __typename: 'Technique', id: string, title: string, body?: any | null, _sys: { __typename?: 'SystemInfo', filename: string, basename: string, breadcrumbs: Array<string>, path: string, relativePath: string, extension: string }, art?: { __typename: 'Art', title: string, video?: string | null, body?: any | null, id: string, parent?: { __typename: 'Art', title: string, video?: string | null, body?: any | null, id: string, links?: Array<{ __typename: 'ArtLinks', label?: string | null, url?: string | null } | null> | null, _sys: { __typename?: 'SystemInfo', filename: string, basename: string, breadcrumbs: Array<string>, path: string, relativePath: string, extension: string } } | null, links?: Array<{ __typename: 'ArtLinks', label?: string | null, url?: string | null } | null> | null, _sys: { __typename?: 'SystemInfo', filename: string, basename: string, breadcrumbs: Array<string>, path: string, relativePath: string, extension: string } } | null, links?: Array<{ __typename: 'TechniqueLinks', label?: string | null, url?: string | null } | null> | null } | null } | null> | null } };

export type ArtQueryVariables = Exact<{
  relativePath: Scalars['String']['input'];
}>;


export type ArtQuery = { __typename?: 'Query', art: { __typename: 'Art', id: string, title: string, video?: string | null, body?: any | null, _sys: { __typename?: 'SystemInfo', filename: string, basename: string, breadcrumbs: Array<string>, path: string, relativePath: string, extension: string }, parent?: { __typename: 'Art', title: string, video?: string | null, body?: any | null, id: string, parent?: { __typename: 'Art', title: string, video?: string | null, body?: any | null, id: string, links?: Array<{ __typename: 'ArtLinks', label?: string | null, url?: string | null } | null> | null, _sys: { __typename?: 'SystemInfo', filename: string, basename: string, breadcrumbs: Array<string>, path: string, relativePath: string, extension: string } } | null, links?: Array<{ __typename: 'ArtLinks', label?: string | null, url?: string | null } | null> | null, _sys: { __typename?: 'SystemInfo', filename: string, basename: string, breadcrumbs: Array<string>, path: string, relativePath: string, extension: string } } | null, links?: Array<{ __typename: 'ArtLinks', label?: string | null, url?: string | null } | null> | null } };

export type ArtConnectionQueryVariables = Exact<{
  before?: InputMaybe<Scalars['String']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Float']['input']>;
  last?: InputMaybe<Scalars['Float']['input']>;
  sort?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<ArtFilter>;
}>;


export type ArtConnectionQuery = { __typename?: 'Query', artConnection: { __typename?: 'ArtConnection', totalCount: number, pageInfo: { __typename?: 'PageInfo', hasPreviousPage: boolean, hasNextPage: boolean, startCursor: string, endCursor: string }, edges?: Array<{ __typename?: 'ArtConnectionEdges', cursor: string, node?: { __typename: 'Art', id: string, title: string, video?: string | null, body?: any | null, _sys: { __typename?: 'SystemInfo', filename: string, basename: string, breadcrumbs: Array<string>, path: string, relativePath: string, extension: string }, parent?: { __typename: 'Art', title: string, video?: string | null, body?: any | null, id: string, parent?: { __typename: 'Art', title: string, video?: string | null, body?: any | null, id: string, links?: Array<{ __typename: 'ArtLinks', label?: string | null, url?: string | null } | null> | null, _sys: { __typename?: 'SystemInfo', filename: string, basename: string, breadcrumbs: Array<string>, path: string, relativePath: string, extension: string } } | null, links?: Array<{ __typename: 'ArtLinks', label?: string | null, url?: string | null } | null> | null, _sys: { __typename?: 'SystemInfo', filename: string, basename: string, breadcrumbs: Array<string>, path: string, relativePath: string, extension: string } } | null, links?: Array<{ __typename: 'ArtLinks', label?: string | null, url?: string | null } | null> | null } | null } | null> | null } };

export type MoveQueryVariables = Exact<{
  relativePath: Scalars['String']['input'];
}>;


export type MoveQuery = { __typename?: 'Query', move: { __typename: 'Move', id: string, title: string, description?: any | null, instruction?: any | null, video?: string | null, body?: any | null, tags?: Array<string | null> | null, _sys: { __typename?: 'SystemInfo', filename: string, basename: string, breadcrumbs: Array<string>, path: string, relativePath: string, extension: string }, art?: { __typename: 'Art', title: string, video?: string | null, body?: any | null, id: string, parent?: { __typename: 'Art', title: string, video?: string | null, body?: any | null, id: string, links?: Array<{ __typename: 'ArtLinks', label?: string | null, url?: string | null } | null> | null, _sys: { __typename?: 'SystemInfo', filename: string, basename: string, breadcrumbs: Array<string>, path: string, relativePath: string, extension: string } } | null, links?: Array<{ __typename: 'ArtLinks', label?: string | null, url?: string | null } | null> | null, _sys: { __typename?: 'SystemInfo', filename: string, basename: string, breadcrumbs: Array<string>, path: string, relativePath: string, extension: string } } | null, links?: Array<{ __typename: 'MoveLinks', label?: string | null, url?: string | null } | null> | null, moves?: Array<{ __typename: 'MoveMoves', data?: { __typename: 'Move', title: string, description?: any | null, instruction?: any | null, video?: string | null, body?: any | null, tags?: Array<string | null> | null, id: string, art?: { __typename: 'Art', title: string, video?: string | null, body?: any | null, id: string, links?: Array<{ __typename: 'ArtLinks', label?: string | null, url?: string | null } | null> | null, _sys: { __typename?: 'SystemInfo', filename: string, basename: string, breadcrumbs: Array<string>, path: string, relativePath: string, extension: string } } | null, links?: Array<{ __typename: 'MoveLinks', label?: string | null, url?: string | null } | null> | null, moves?: Array<{ __typename: 'MoveMoves', data?: { __typename: 'Move', title: string, description?: any | null, instruction?: any | null, video?: string | null, body?: any | null, tags?: Array<string | null> | null, id: string, links?: Array<{ __typename: 'MoveLinks', label?: string | null, url?: string | null } | null> | null, moves?: Array<{ __typename: 'MoveMoves' } | null> | null, _sys: { __typename?: 'SystemInfo', filename: string, basename: string, breadcrumbs: Array<string>, path: string, relativePath: string, extension: string } } | null } | null> | null, _sys: { __typename?: 'SystemInfo', filename: string, basename: string, breadcrumbs: Array<string>, path: string, relativePath: string, extension: string } } | null } | null> | null } };

export type MoveConnectionQueryVariables = Exact<{
  before?: InputMaybe<Scalars['String']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Float']['input']>;
  last?: InputMaybe<Scalars['Float']['input']>;
  sort?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<MoveFilter>;
}>;


export type MoveConnectionQuery = { __typename?: 'Query', moveConnection: { __typename?: 'MoveConnection', totalCount: number, pageInfo: { __typename?: 'PageInfo', hasPreviousPage: boolean, hasNextPage: boolean, startCursor: string, endCursor: string }, edges?: Array<{ __typename?: 'MoveConnectionEdges', cursor: string, node?: { __typename: 'Move', id: string, title: string, description?: any | null, instruction?: any | null, video?: string | null, body?: any | null, tags?: Array<string | null> | null, _sys: { __typename?: 'SystemInfo', filename: string, basename: string, breadcrumbs: Array<string>, path: string, relativePath: string, extension: string }, art?: { __typename: 'Art', title: string, video?: string | null, body?: any | null, id: string, parent?: { __typename: 'Art', title: string, video?: string | null, body?: any | null, id: string, links?: Array<{ __typename: 'ArtLinks', label?: string | null, url?: string | null } | null> | null, _sys: { __typename?: 'SystemInfo', filename: string, basename: string, breadcrumbs: Array<string>, path: string, relativePath: string, extension: string } } | null, links?: Array<{ __typename: 'ArtLinks', label?: string | null, url?: string | null } | null> | null, _sys: { __typename?: 'SystemInfo', filename: string, basename: string, breadcrumbs: Array<string>, path: string, relativePath: string, extension: string } } | null, links?: Array<{ __typename: 'MoveLinks', label?: string | null, url?: string | null } | null> | null, moves?: Array<{ __typename: 'MoveMoves', data?: { __typename: 'Move', title: string, description?: any | null, instruction?: any | null, video?: string | null, body?: any | null, tags?: Array<string | null> | null, id: string, art?: { __typename: 'Art', title: string, video?: string | null, body?: any | null, id: string, links?: Array<{ __typename: 'ArtLinks', label?: string | null, url?: string | null } | null> | null, _sys: { __typename?: 'SystemInfo', filename: string, basename: string, breadcrumbs: Array<string>, path: string, relativePath: string, extension: string } } | null, links?: Array<{ __typename: 'MoveLinks', label?: string | null, url?: string | null } | null> | null, moves?: Array<{ __typename: 'MoveMoves', data?: { __typename: 'Move', title: string, description?: any | null, instruction?: any | null, video?: string | null, body?: any | null, tags?: Array<string | null> | null, id: string, links?: Array<{ __typename: 'MoveLinks', label?: string | null, url?: string | null } | null> | null, moves?: Array<{ __typename: 'MoveMoves' } | null> | null, _sys: { __typename?: 'SystemInfo', filename: string, basename: string, breadcrumbs: Array<string>, path: string, relativePath: string, extension: string } } | null } | null> | null, _sys: { __typename?: 'SystemInfo', filename: string, basename: string, breadcrumbs: Array<string>, path: string, relativePath: string, extension: string } } | null } | null> | null } | null } | null> | null } };

export type ExerciseQueryVariables = Exact<{
  relativePath: Scalars['String']['input'];
}>;


export type ExerciseQuery = { __typename?: 'Query', exercise: { __typename: 'Exercise', id: string, title: string, excerpt?: string | null, body?: any | null, difficulty: string, locomotion?: Array<string | null> | null, personal?: Array<string | null> | null, tags?: Array<string | null> | null, video?: string | null, _sys: { __typename?: 'SystemInfo', filename: string, basename: string, breadcrumbs: Array<string>, path: string, relativePath: string, extension: string }, media?: Array<{ __typename: 'ExerciseMediaDancemix', label?: string | null, duration?: number | null, pause?: number | null, amount?: number | null, playlist?: string | null } | { __typename: 'ExerciseMediaSong', id: string, play: string, start?: number | null } | { __typename: 'ExerciseMediaLoop', name?: string | null } | { __typename: 'ExerciseMediaMaterial', material?: Array<string | null> | null } | null> | null, instruction?: Array<{ __typename: 'ExerciseInstruction', title?: string | null, duration?: number | null, content?: any | null, method?: string | null, goal?: string | null, move?: { __typename: 'Move', title: string, description?: any | null, instruction?: any | null, video?: string | null, body?: any | null, tags?: Array<string | null> | null, id: string, art?: { __typename: 'Art', title: string, video?: string | null, body?: any | null, id: string, links?: Array<{ __typename: 'ArtLinks', label?: string | null, url?: string | null } | null> | null, _sys: { __typename?: 'SystemInfo', filename: string, basename: string, breadcrumbs: Array<string>, path: string, relativePath: string, extension: string } } | null, links?: Array<{ __typename: 'MoveLinks', label?: string | null, url?: string | null } | null> | null, moves?: Array<{ __typename: 'MoveMoves', data?: { __typename: 'Move', title: string, description?: any | null, instruction?: any | null, video?: string | null, body?: any | null, tags?: Array<string | null> | null, id: string, links?: Array<{ __typename: 'MoveLinks', label?: string | null, url?: string | null } | null> | null, moves?: Array<{ __typename: 'MoveMoves' } | null> | null, _sys: { __typename?: 'SystemInfo', filename: string, basename: string, breadcrumbs: Array<string>, path: string, relativePath: string, extension: string } } | null } | null> | null, _sys: { __typename?: 'SystemInfo', filename: string, basename: string, breadcrumbs: Array<string>, path: string, relativePath: string, extension: string } } | null, media?: Array<{ __typename: 'ExerciseInstructionMediaDancemix', label?: string | null, duration?: number | null, pause?: number | null, amount?: number | null, playlist?: string | null } | { __typename: 'ExerciseInstructionMediaSong', id: string, play: string, start?: number | null } | { __typename: 'ExerciseInstructionMediaLoop', name?: string | null } | { __typename: 'ExerciseInstructionMediaMaterial', material?: Array<string | null> | null } | null> | null } | null> | null, exercises?: Array<{ __typename: 'ExerciseExercises', data?: { __typename: 'Exercise', title: string, excerpt?: string | null, body?: any | null, difficulty: string, locomotion?: Array<string | null> | null, personal?: Array<string | null> | null, tags?: Array<string | null> | null, video?: string | null, id: string, media?: Array<{ __typename: 'ExerciseMediaDancemix', label?: string | null, duration?: number | null, pause?: number | null, amount?: number | null, playlist?: string | null } | { __typename: 'ExerciseMediaSong', id: string, play: string, start?: number | null } | { __typename: 'ExerciseMediaLoop', name?: string | null } | { __typename: 'ExerciseMediaMaterial', material?: Array<string | null> | null } | null> | null, instruction?: Array<{ __typename: 'ExerciseInstruction', title?: string | null, duration?: number | null, content?: any | null, method?: string | null, goal?: string | null, move?: { __typename: 'Move', title: string, description?: any | null, instruction?: any | null, video?: string | null, body?: any | null, tags?: Array<string | null> | null, id: string, links?: Array<{ __typename: 'MoveLinks', label?: string | null, url?: string | null } | null> | null, moves?: Array<{ __typename: 'MoveMoves' } | null> | null, _sys: { __typename?: 'SystemInfo', filename: string, basename: string, breadcrumbs: Array<string>, path: string, relativePath: string, extension: string } } | null, media?: Array<{ __typename: 'ExerciseInstructionMediaDancemix', label?: string | null, duration?: number | null, pause?: number | null, amount?: number | null, playlist?: string | null } | { __typename: 'ExerciseInstructionMediaSong', id: string, play: string, start?: number | null } | { __typename: 'ExerciseInstructionMediaLoop', name?: string | null } | { __typename: 'ExerciseInstructionMediaMaterial', material?: Array<string | null> | null } | null> | null } | null> | null, exercises?: Array<{ __typename: 'ExerciseExercises', data?: { __typename: 'Exercise', title: string, excerpt?: string | null, body?: any | null, difficulty: string, locomotion?: Array<string | null> | null, personal?: Array<string | null> | null, tags?: Array<string | null> | null, video?: string | null, id: string, media?: Array<{ __typename: 'ExerciseMediaDancemix', label?: string | null, duration?: number | null, pause?: number | null, amount?: number | null, playlist?: string | null } | { __typename: 'ExerciseMediaSong', id: string, play: string, start?: number | null } | { __typename: 'ExerciseMediaLoop', name?: string | null } | { __typename: 'ExerciseMediaMaterial', material?: Array<string | null> | null } | null> | null, instruction?: Array<{ __typename: 'ExerciseInstruction', title?: string | null, duration?: number | null, content?: any | null, method?: string | null, goal?: string | null, media?: Array<{ __typename: 'ExerciseInstructionMediaDancemix', label?: string | null, duration?: number | null, pause?: number | null, amount?: number | null, playlist?: string | null } | { __typename: 'ExerciseInstructionMediaSong', id: string, play: string, start?: number | null } | { __typename: 'ExerciseInstructionMediaLoop', name?: string | null } | { __typename: 'ExerciseInstructionMediaMaterial', material?: Array<string | null> | null } | null> | null } | null> | null, exercises?: Array<{ __typename: 'ExerciseExercises' } | null> | null, links?: Array<{ __typename: 'ExerciseLinks', label?: string | null, url?: string | null } | null> | null, skills?: Array<{ __typename: 'ExerciseSkills' } | null> | null, _sys: { __typename?: 'SystemInfo', filename: string, basename: string, breadcrumbs: Array<string>, path: string, relativePath: string, extension: string } } | null } | null> | null, links?: Array<{ __typename: 'ExerciseLinks', label?: string | null, url?: string | null } | null> | null, art?: { __typename: 'Art', title: string, video?: string | null, body?: any | null, id: string, links?: Array<{ __typename: 'ArtLinks', label?: string | null, url?: string | null } | null> | null, _sys: { __typename?: 'SystemInfo', filename: string, basename: string, breadcrumbs: Array<string>, path: string, relativePath: string, extension: string } } | null, technique?: { __typename: 'Technique', title: string, body?: any | null, id: string, links?: Array<{ __typename: 'TechniqueLinks', label?: string | null, url?: string | null } | null> | null, _sys: { __typename?: 'SystemInfo', filename: string, basename: string, breadcrumbs: Array<string>, path: string, relativePath: string, extension: string } } | null, skills?: Array<{ __typename: 'ExerciseSkills', data?: { __typename: 'Skill', title: string, body?: any | null, id: string, _sys: { __typename?: 'SystemInfo', filename: string, basename: string, breadcrumbs: Array<string>, path: string, relativePath: string, extension: string } } | null } | null> | null, _sys: { __typename?: 'SystemInfo', filename: string, basename: string, breadcrumbs: Array<string>, path: string, relativePath: string, extension: string } } | null } | null> | null, links?: Array<{ __typename: 'ExerciseLinks', label?: string | null, url?: string | null } | null> | null, art?: { __typename: 'Art', title: string, video?: string | null, body?: any | null, id: string, parent?: { __typename: 'Art', title: string, video?: string | null, body?: any | null, id: string, links?: Array<{ __typename: 'ArtLinks', label?: string | null, url?: string | null } | null> | null, _sys: { __typename?: 'SystemInfo', filename: string, basename: string, breadcrumbs: Array<string>, path: string, relativePath: string, extension: string } } | null, links?: Array<{ __typename: 'ArtLinks', label?: string | null, url?: string | null } | null> | null, _sys: { __typename?: 'SystemInfo', filename: string, basename: string, breadcrumbs: Array<string>, path: string, relativePath: string, extension: string } } | null, technique?: { __typename: 'Technique', title: string, body?: any | null, id: string, art?: { __typename: 'Art', title: string, video?: string | null, body?: any | null, id: string, links?: Array<{ __typename: 'ArtLinks', label?: string | null, url?: string | null } | null> | null, _sys: { __typename?: 'SystemInfo', filename: string, basename: string, breadcrumbs: Array<string>, path: string, relativePath: string, extension: string } } | null, links?: Array<{ __typename: 'TechniqueLinks', label?: string | null, url?: string | null } | null> | null, _sys: { __typename?: 'SystemInfo', filename: string, basename: string, breadcrumbs: Array<string>, path: string, relativePath: string, extension: string } } | null, skills?: Array<{ __typename: 'ExerciseSkills', data?: { __typename: 'Skill', title: string, body?: any | null, id: string, _sys: { __typename?: 'SystemInfo', filename: string, basename: string, breadcrumbs: Array<string>, path: string, relativePath: string, extension: string } } | null } | null> | null } };

export type ExerciseConnectionQueryVariables = Exact<{
  before?: InputMaybe<Scalars['String']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Float']['input']>;
  last?: InputMaybe<Scalars['Float']['input']>;
  sort?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<ExerciseFilter>;
}>;


export type ExerciseConnectionQuery = { __typename?: 'Query', exerciseConnection: { __typename?: 'ExerciseConnection', totalCount: number, pageInfo: { __typename?: 'PageInfo', hasPreviousPage: boolean, hasNextPage: boolean, startCursor: string, endCursor: string }, edges?: Array<{ __typename?: 'ExerciseConnectionEdges', cursor: string, node?: { __typename: 'Exercise', id: string, title: string, excerpt?: string | null, body?: any | null, difficulty: string, locomotion?: Array<string | null> | null, personal?: Array<string | null> | null, tags?: Array<string | null> | null, video?: string | null, _sys: { __typename?: 'SystemInfo', filename: string, basename: string, breadcrumbs: Array<string>, path: string, relativePath: string, extension: string }, media?: Array<{ __typename: 'ExerciseMediaDancemix', label?: string | null, duration?: number | null, pause?: number | null, amount?: number | null, playlist?: string | null } | { __typename: 'ExerciseMediaSong', id: string, play: string, start?: number | null } | { __typename: 'ExerciseMediaLoop', name?: string | null } | { __typename: 'ExerciseMediaMaterial', material?: Array<string | null> | null } | null> | null, instruction?: Array<{ __typename: 'ExerciseInstruction', title?: string | null, duration?: number | null, content?: any | null, method?: string | null, goal?: string | null, move?: { __typename: 'Move', title: string, description?: any | null, instruction?: any | null, video?: string | null, body?: any | null, tags?: Array<string | null> | null, id: string, art?: { __typename: 'Art', title: string, video?: string | null, body?: any | null, id: string, links?: Array<{ __typename: 'ArtLinks', label?: string | null, url?: string | null } | null> | null, _sys: { __typename?: 'SystemInfo', filename: string, basename: string, breadcrumbs: Array<string>, path: string, relativePath: string, extension: string } } | null, links?: Array<{ __typename: 'MoveLinks', label?: string | null, url?: string | null } | null> | null, moves?: Array<{ __typename: 'MoveMoves', data?: { __typename: 'Move', title: string, description?: any | null, instruction?: any | null, video?: string | null, body?: any | null, tags?: Array<string | null> | null, id: string, links?: Array<{ __typename: 'MoveLinks', label?: string | null, url?: string | null } | null> | null, moves?: Array<{ __typename: 'MoveMoves' } | null> | null, _sys: { __typename?: 'SystemInfo', filename: string, basename: string, breadcrumbs: Array<string>, path: string, relativePath: string, extension: string } } | null } | null> | null, _sys: { __typename?: 'SystemInfo', filename: string, basename: string, breadcrumbs: Array<string>, path: string, relativePath: string, extension: string } } | null, media?: Array<{ __typename: 'ExerciseInstructionMediaDancemix', label?: string | null, duration?: number | null, pause?: number | null, amount?: number | null, playlist?: string | null } | { __typename: 'ExerciseInstructionMediaSong', id: string, play: string, start?: number | null } | { __typename: 'ExerciseInstructionMediaLoop', name?: string | null } | { __typename: 'ExerciseInstructionMediaMaterial', material?: Array<string | null> | null } | null> | null } | null> | null, exercises?: Array<{ __typename: 'ExerciseExercises', data?: { __typename: 'Exercise', title: string, excerpt?: string | null, body?: any | null, difficulty: string, locomotion?: Array<string | null> | null, personal?: Array<string | null> | null, tags?: Array<string | null> | null, video?: string | null, id: string, media?: Array<{ __typename: 'ExerciseMediaDancemix', label?: string | null, duration?: number | null, pause?: number | null, amount?: number | null, playlist?: string | null } | { __typename: 'ExerciseMediaSong', id: string, play: string, start?: number | null } | { __typename: 'ExerciseMediaLoop', name?: string | null } | { __typename: 'ExerciseMediaMaterial', material?: Array<string | null> | null } | null> | null, instruction?: Array<{ __typename: 'ExerciseInstruction', title?: string | null, duration?: number | null, content?: any | null, method?: string | null, goal?: string | null, move?: { __typename: 'Move', title: string, description?: any | null, instruction?: any | null, video?: string | null, body?: any | null, tags?: Array<string | null> | null, id: string, links?: Array<{ __typename: 'MoveLinks', label?: string | null, url?: string | null } | null> | null, moves?: Array<{ __typename: 'MoveMoves' } | null> | null, _sys: { __typename?: 'SystemInfo', filename: string, basename: string, breadcrumbs: Array<string>, path: string, relativePath: string, extension: string } } | null, media?: Array<{ __typename: 'ExerciseInstructionMediaDancemix', label?: string | null, duration?: number | null, pause?: number | null, amount?: number | null, playlist?: string | null } | { __typename: 'ExerciseInstructionMediaSong', id: string, play: string, start?: number | null } | { __typename: 'ExerciseInstructionMediaLoop', name?: string | null } | { __typename: 'ExerciseInstructionMediaMaterial', material?: Array<string | null> | null } | null> | null } | null> | null, exercises?: Array<{ __typename: 'ExerciseExercises', data?: { __typename: 'Exercise', title: string, excerpt?: string | null, body?: any | null, difficulty: string, locomotion?: Array<string | null> | null, personal?: Array<string | null> | null, tags?: Array<string | null> | null, video?: string | null, id: string, media?: Array<{ __typename: 'ExerciseMediaDancemix', label?: string | null, duration?: number | null, pause?: number | null, amount?: number | null, playlist?: string | null } | { __typename: 'ExerciseMediaSong', id: string, play: string, start?: number | null } | { __typename: 'ExerciseMediaLoop', name?: string | null } | { __typename: 'ExerciseMediaMaterial', material?: Array<string | null> | null } | null> | null, instruction?: Array<{ __typename: 'ExerciseInstruction', title?: string | null, duration?: number | null, content?: any | null, method?: string | null, goal?: string | null, media?: Array<{ __typename: 'ExerciseInstructionMediaDancemix', label?: string | null, duration?: number | null, pause?: number | null, amount?: number | null, playlist?: string | null } | { __typename: 'ExerciseInstructionMediaSong', id: string, play: string, start?: number | null } | { __typename: 'ExerciseInstructionMediaLoop', name?: string | null } | { __typename: 'ExerciseInstructionMediaMaterial', material?: Array<string | null> | null } | null> | null } | null> | null, exercises?: Array<{ __typename: 'ExerciseExercises' } | null> | null, links?: Array<{ __typename: 'ExerciseLinks', label?: string | null, url?: string | null } | null> | null, skills?: Array<{ __typename: 'ExerciseSkills' } | null> | null, _sys: { __typename?: 'SystemInfo', filename: string, basename: string, breadcrumbs: Array<string>, path: string, relativePath: string, extension: string } } | null } | null> | null, links?: Array<{ __typename: 'ExerciseLinks', label?: string | null, url?: string | null } | null> | null, art?: { __typename: 'Art', title: string, video?: string | null, body?: any | null, id: string, links?: Array<{ __typename: 'ArtLinks', label?: string | null, url?: string | null } | null> | null, _sys: { __typename?: 'SystemInfo', filename: string, basename: string, breadcrumbs: Array<string>, path: string, relativePath: string, extension: string } } | null, technique?: { __typename: 'Technique', title: string, body?: any | null, id: string, links?: Array<{ __typename: 'TechniqueLinks', label?: string | null, url?: string | null } | null> | null, _sys: { __typename?: 'SystemInfo', filename: string, basename: string, breadcrumbs: Array<string>, path: string, relativePath: string, extension: string } } | null, skills?: Array<{ __typename: 'ExerciseSkills', data?: { __typename: 'Skill', title: string, body?: any | null, id: string, _sys: { __typename?: 'SystemInfo', filename: string, basename: string, breadcrumbs: Array<string>, path: string, relativePath: string, extension: string } } | null } | null> | null, _sys: { __typename?: 'SystemInfo', filename: string, basename: string, breadcrumbs: Array<string>, path: string, relativePath: string, extension: string } } | null } | null> | null, links?: Array<{ __typename: 'ExerciseLinks', label?: string | null, url?: string | null } | null> | null, art?: { __typename: 'Art', title: string, video?: string | null, body?: any | null, id: string, parent?: { __typename: 'Art', title: string, video?: string | null, body?: any | null, id: string, links?: Array<{ __typename: 'ArtLinks', label?: string | null, url?: string | null } | null> | null, _sys: { __typename?: 'SystemInfo', filename: string, basename: string, breadcrumbs: Array<string>, path: string, relativePath: string, extension: string } } | null, links?: Array<{ __typename: 'ArtLinks', label?: string | null, url?: string | null } | null> | null, _sys: { __typename?: 'SystemInfo', filename: string, basename: string, breadcrumbs: Array<string>, path: string, relativePath: string, extension: string } } | null, technique?: { __typename: 'Technique', title: string, body?: any | null, id: string, art?: { __typename: 'Art', title: string, video?: string | null, body?: any | null, id: string, links?: Array<{ __typename: 'ArtLinks', label?: string | null, url?: string | null } | null> | null, _sys: { __typename?: 'SystemInfo', filename: string, basename: string, breadcrumbs: Array<string>, path: string, relativePath: string, extension: string } } | null, links?: Array<{ __typename: 'TechniqueLinks', label?: string | null, url?: string | null } | null> | null, _sys: { __typename?: 'SystemInfo', filename: string, basename: string, breadcrumbs: Array<string>, path: string, relativePath: string, extension: string } } | null, skills?: Array<{ __typename: 'ExerciseSkills', data?: { __typename: 'Skill', title: string, body?: any | null, id: string, _sys: { __typename?: 'SystemInfo', filename: string, basename: string, breadcrumbs: Array<string>, path: string, relativePath: string, extension: string } } | null } | null> | null } | null } | null> | null } };

export type CourseQueryVariables = Exact<{
  relativePath: Scalars['String']['input'];
}>;


export type CourseQuery = { __typename?: 'Query', course: { __typename: 'Course', id: string, title: string, description?: string | null, about?: string | null, learn?: Array<string | null> | null, examples?: Array<string | null> | null, _sys: { __typename?: 'SystemInfo', filename: string, basename: string, breadcrumbs: Array<string>, path: string, relativePath: string, extension: string }, lessons?: Array<{ __typename: 'CourseLessonsLesson', title?: string | null, description?: string | null, exercises?: Array<{ __typename: 'CourseLessonsLessonExercises', data?: { __typename: 'Exercise', title: string, excerpt?: string | null, body?: any | null, difficulty: string, locomotion?: Array<string | null> | null, personal?: Array<string | null> | null, tags?: Array<string | null> | null, video?: string | null, id: string, media?: Array<{ __typename: 'ExerciseMediaDancemix', label?: string | null, duration?: number | null, pause?: number | null, amount?: number | null, playlist?: string | null } | { __typename: 'ExerciseMediaSong', id: string, play: string, start?: number | null } | { __typename: 'ExerciseMediaLoop', name?: string | null } | { __typename: 'ExerciseMediaMaterial', material?: Array<string | null> | null } | null> | null, instruction?: Array<{ __typename: 'ExerciseInstruction', title?: string | null, duration?: number | null, content?: any | null, method?: string | null, goal?: string | null, move?: { __typename: 'Move', title: string, description?: any | null, instruction?: any | null, video?: string | null, body?: any | null, tags?: Array<string | null> | null, id: string, links?: Array<{ __typename: 'MoveLinks', label?: string | null, url?: string | null } | null> | null, moves?: Array<{ __typename: 'MoveMoves' } | null> | null, _sys: { __typename?: 'SystemInfo', filename: string, basename: string, breadcrumbs: Array<string>, path: string, relativePath: string, extension: string } } | null, media?: Array<{ __typename: 'ExerciseInstructionMediaDancemix', label?: string | null, duration?: number | null, pause?: number | null, amount?: number | null, playlist?: string | null } | { __typename: 'ExerciseInstructionMediaSong', id: string, play: string, start?: number | null } | { __typename: 'ExerciseInstructionMediaLoop', name?: string | null } | { __typename: 'ExerciseInstructionMediaMaterial', material?: Array<string | null> | null } | null> | null } | null> | null, exercises?: Array<{ __typename: 'ExerciseExercises', data?: { __typename: 'Exercise', title: string, excerpt?: string | null, body?: any | null, difficulty: string, locomotion?: Array<string | null> | null, personal?: Array<string | null> | null, tags?: Array<string | null> | null, video?: string | null, id: string, media?: Array<{ __typename: 'ExerciseMediaDancemix', label?: string | null, duration?: number | null, pause?: number | null, amount?: number | null, playlist?: string | null } | { __typename: 'ExerciseMediaSong', id: string, play: string, start?: number | null } | { __typename: 'ExerciseMediaLoop', name?: string | null } | { __typename: 'ExerciseMediaMaterial', material?: Array<string | null> | null } | null> | null, instruction?: Array<{ __typename: 'ExerciseInstruction', title?: string | null, duration?: number | null, content?: any | null, method?: string | null, goal?: string | null, media?: Array<{ __typename: 'ExerciseInstructionMediaDancemix', label?: string | null, duration?: number | null, pause?: number | null, amount?: number | null, playlist?: string | null } | { __typename: 'ExerciseInstructionMediaSong', id: string, play: string, start?: number | null } | { __typename: 'ExerciseInstructionMediaLoop', name?: string | null } | { __typename: 'ExerciseInstructionMediaMaterial', material?: Array<string | null> | null } | null> | null } | null> | null, exercises?: Array<{ __typename: 'ExerciseExercises' } | null> | null, links?: Array<{ __typename: 'ExerciseLinks', label?: string | null, url?: string | null } | null> | null, skills?: Array<{ __typename: 'ExerciseSkills' } | null> | null, _sys: { __typename?: 'SystemInfo', filename: string, basename: string, breadcrumbs: Array<string>, path: string, relativePath: string, extension: string } } | null } | null> | null, links?: Array<{ __typename: 'ExerciseLinks', label?: string | null, url?: string | null } | null> | null, art?: { __typename: 'Art', title: string, video?: string | null, body?: any | null, id: string, links?: Array<{ __typename: 'ArtLinks', label?: string | null, url?: string | null } | null> | null, _sys: { __typename?: 'SystemInfo', filename: string, basename: string, breadcrumbs: Array<string>, path: string, relativePath: string, extension: string } } | null, technique?: { __typename: 'Technique', title: string, body?: any | null, id: string, links?: Array<{ __typename: 'TechniqueLinks', label?: string | null, url?: string | null } | null> | null, _sys: { __typename?: 'SystemInfo', filename: string, basename: string, breadcrumbs: Array<string>, path: string, relativePath: string, extension: string } } | null, skills?: Array<{ __typename: 'ExerciseSkills', data?: { __typename: 'Skill', title: string, body?: any | null, id: string, _sys: { __typename?: 'SystemInfo', filename: string, basename: string, breadcrumbs: Array<string>, path: string, relativePath: string, extension: string } } | null } | null> | null, _sys: { __typename?: 'SystemInfo', filename: string, basename: string, breadcrumbs: Array<string>, path: string, relativePath: string, extension: string } } | null } | null> | null } | null> | null } };

export type CourseConnectionQueryVariables = Exact<{
  before?: InputMaybe<Scalars['String']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Float']['input']>;
  last?: InputMaybe<Scalars['Float']['input']>;
  sort?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<CourseFilter>;
}>;


export type CourseConnectionQuery = { __typename?: 'Query', courseConnection: { __typename?: 'CourseConnection', totalCount: number, pageInfo: { __typename?: 'PageInfo', hasPreviousPage: boolean, hasNextPage: boolean, startCursor: string, endCursor: string }, edges?: Array<{ __typename?: 'CourseConnectionEdges', cursor: string, node?: { __typename: 'Course', id: string, title: string, description?: string | null, about?: string | null, learn?: Array<string | null> | null, examples?: Array<string | null> | null, _sys: { __typename?: 'SystemInfo', filename: string, basename: string, breadcrumbs: Array<string>, path: string, relativePath: string, extension: string }, lessons?: Array<{ __typename: 'CourseLessonsLesson', title?: string | null, description?: string | null, exercises?: Array<{ __typename: 'CourseLessonsLessonExercises', data?: { __typename: 'Exercise', title: string, excerpt?: string | null, body?: any | null, difficulty: string, locomotion?: Array<string | null> | null, personal?: Array<string | null> | null, tags?: Array<string | null> | null, video?: string | null, id: string, media?: Array<{ __typename: 'ExerciseMediaDancemix', label?: string | null, duration?: number | null, pause?: number | null, amount?: number | null, playlist?: string | null } | { __typename: 'ExerciseMediaSong', id: string, play: string, start?: number | null } | { __typename: 'ExerciseMediaLoop', name?: string | null } | { __typename: 'ExerciseMediaMaterial', material?: Array<string | null> | null } | null> | null, instruction?: Array<{ __typename: 'ExerciseInstruction', title?: string | null, duration?: number | null, content?: any | null, method?: string | null, goal?: string | null, move?: { __typename: 'Move', title: string, description?: any | null, instruction?: any | null, video?: string | null, body?: any | null, tags?: Array<string | null> | null, id: string, links?: Array<{ __typename: 'MoveLinks', label?: string | null, url?: string | null } | null> | null, moves?: Array<{ __typename: 'MoveMoves' } | null> | null, _sys: { __typename?: 'SystemInfo', filename: string, basename: string, breadcrumbs: Array<string>, path: string, relativePath: string, extension: string } } | null, media?: Array<{ __typename: 'ExerciseInstructionMediaDancemix', label?: string | null, duration?: number | null, pause?: number | null, amount?: number | null, playlist?: string | null } | { __typename: 'ExerciseInstructionMediaSong', id: string, play: string, start?: number | null } | { __typename: 'ExerciseInstructionMediaLoop', name?: string | null } | { __typename: 'ExerciseInstructionMediaMaterial', material?: Array<string | null> | null } | null> | null } | null> | null, exercises?: Array<{ __typename: 'ExerciseExercises', data?: { __typename: 'Exercise', title: string, excerpt?: string | null, body?: any | null, difficulty: string, locomotion?: Array<string | null> | null, personal?: Array<string | null> | null, tags?: Array<string | null> | null, video?: string | null, id: string, media?: Array<{ __typename: 'ExerciseMediaDancemix', label?: string | null, duration?: number | null, pause?: number | null, amount?: number | null, playlist?: string | null } | { __typename: 'ExerciseMediaSong', id: string, play: string, start?: number | null } | { __typename: 'ExerciseMediaLoop', name?: string | null } | { __typename: 'ExerciseMediaMaterial', material?: Array<string | null> | null } | null> | null, instruction?: Array<{ __typename: 'ExerciseInstruction', title?: string | null, duration?: number | null, content?: any | null, method?: string | null, goal?: string | null, media?: Array<{ __typename: 'ExerciseInstructionMediaDancemix', label?: string | null, duration?: number | null, pause?: number | null, amount?: number | null, playlist?: string | null } | { __typename: 'ExerciseInstructionMediaSong', id: string, play: string, start?: number | null } | { __typename: 'ExerciseInstructionMediaLoop', name?: string | null } | { __typename: 'ExerciseInstructionMediaMaterial', material?: Array<string | null> | null } | null> | null } | null> | null, exercises?: Array<{ __typename: 'ExerciseExercises' } | null> | null, links?: Array<{ __typename: 'ExerciseLinks', label?: string | null, url?: string | null } | null> | null, skills?: Array<{ __typename: 'ExerciseSkills' } | null> | null, _sys: { __typename?: 'SystemInfo', filename: string, basename: string, breadcrumbs: Array<string>, path: string, relativePath: string, extension: string } } | null } | null> | null, links?: Array<{ __typename: 'ExerciseLinks', label?: string | null, url?: string | null } | null> | null, art?: { __typename: 'Art', title: string, video?: string | null, body?: any | null, id: string, links?: Array<{ __typename: 'ArtLinks', label?: string | null, url?: string | null } | null> | null, _sys: { __typename?: 'SystemInfo', filename: string, basename: string, breadcrumbs: Array<string>, path: string, relativePath: string, extension: string } } | null, technique?: { __typename: 'Technique', title: string, body?: any | null, id: string, links?: Array<{ __typename: 'TechniqueLinks', label?: string | null, url?: string | null } | null> | null, _sys: { __typename?: 'SystemInfo', filename: string, basename: string, breadcrumbs: Array<string>, path: string, relativePath: string, extension: string } } | null, skills?: Array<{ __typename: 'ExerciseSkills', data?: { __typename: 'Skill', title: string, body?: any | null, id: string, _sys: { __typename?: 'SystemInfo', filename: string, basename: string, breadcrumbs: Array<string>, path: string, relativePath: string, extension: string } } | null } | null> | null, _sys: { __typename?: 'SystemInfo', filename: string, basename: string, breadcrumbs: Array<string>, path: string, relativePath: string, extension: string } } | null } | null> | null } | null> | null } | null } | null> | null } };

export type AwfulpracticeQueryVariables = Exact<{
  relativePath: Scalars['String']['input'];
}>;


export type AwfulpracticeQuery = { __typename?: 'Query', awfulpractice: { __typename: 'Awfulpractice', id: string, title: string, tags?: Array<string | null> | null, body?: any | null, _sys: { __typename?: 'SystemInfo', filename: string, basename: string, breadcrumbs: Array<string>, path: string, relativePath: string, extension: string } } };

export type AwfulpracticeConnectionQueryVariables = Exact<{
  before?: InputMaybe<Scalars['String']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Float']['input']>;
  last?: InputMaybe<Scalars['Float']['input']>;
  sort?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<AwfulpracticeFilter>;
}>;


export type AwfulpracticeConnectionQuery = { __typename?: 'Query', awfulpracticeConnection: { __typename?: 'AwfulpracticeConnection', totalCount: number, pageInfo: { __typename?: 'PageInfo', hasPreviousPage: boolean, hasNextPage: boolean, startCursor: string, endCursor: string }, edges?: Array<{ __typename?: 'AwfulpracticeConnectionEdges', cursor: string, node?: { __typename: 'Awfulpractice', id: string, title: string, tags?: Array<string | null> | null, body?: any | null, _sys: { __typename?: 'SystemInfo', filename: string, basename: string, breadcrumbs: Array<string>, path: string, relativePath: string, extension: string } } | null } | null> | null } };

export type RoutinesQueryVariables = Exact<{
  relativePath: Scalars['String']['input'];
}>;


export type RoutinesQuery = { __typename?: 'Query', routines: { __typename: 'Routines', id: string, rider: string, type: string, event?: string | null, date?: string | null, video: string, notTodoList?: Array<string | null> | null, _sys: { __typename?: 'SystemInfo', filename: string, basename: string, breadcrumbs: Array<string>, path: string, relativePath: string, extension: string }, timeTracking?: { __typename: 'RoutinesTimeTracking', start?: number | null, end?: number | null, duration?: number | null, scenes?: Array<{ __typename: 'RoutinesTimeTrackingScenes', start?: number | null, end?: number | null, category?: string | null } | null> | null, evaluation?: { __typename: 'RoutinesTimeTrackingEvaluation', artistry?: { __typename: 'RoutinesTimeTrackingEvaluationArtistry', duration?: number | null, ratio?: number | null } | null, communication?: { __typename: 'RoutinesTimeTrackingEvaluationCommunication', duration?: number | null, ratio?: number | null } | null, tricks?: { __typename: 'RoutinesTimeTrackingEvaluationTricks', duration?: number | null, ratio?: number | null } | null, filler?: { __typename: 'RoutinesTimeTrackingEvaluationFiller', duration?: number | null, ratio?: number | null } | null, void?: { __typename: 'RoutinesTimeTrackingEvaluationVoid', duration?: number | null, ratio?: number | null } | null, dismounts?: { __typename: 'RoutinesTimeTrackingEvaluationDismounts', duration?: number | null, ratio?: number | null } | null } | null } | null, artistic?: { __typename: 'RoutinesArtistic', name: string, score?: number | null, parts?: Array<{ __typename: 'RoutinesArtisticParts', name: string, score?: number | null, categories?: Array<{ __typename: 'RoutinesArtisticPartsCategories', name: string, score?: number | null, criteria?: Array<{ __typename: 'RoutinesArtisticPartsCategoriesCriteria', name: string, value?: number | null } | null> | null } | null> | null } | null> | null } | null } };

export type RoutinesConnectionQueryVariables = Exact<{
  before?: InputMaybe<Scalars['String']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Float']['input']>;
  last?: InputMaybe<Scalars['Float']['input']>;
  sort?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<RoutinesFilter>;
}>;


export type RoutinesConnectionQuery = { __typename?: 'Query', routinesConnection: { __typename?: 'RoutinesConnection', totalCount: number, pageInfo: { __typename?: 'PageInfo', hasPreviousPage: boolean, hasNextPage: boolean, startCursor: string, endCursor: string }, edges?: Array<{ __typename?: 'RoutinesConnectionEdges', cursor: string, node?: { __typename: 'Routines', id: string, rider: string, type: string, event?: string | null, date?: string | null, video: string, notTodoList?: Array<string | null> | null, _sys: { __typename?: 'SystemInfo', filename: string, basename: string, breadcrumbs: Array<string>, path: string, relativePath: string, extension: string }, timeTracking?: { __typename: 'RoutinesTimeTracking', start?: number | null, end?: number | null, duration?: number | null, scenes?: Array<{ __typename: 'RoutinesTimeTrackingScenes', start?: number | null, end?: number | null, category?: string | null } | null> | null, evaluation?: { __typename: 'RoutinesTimeTrackingEvaluation', artistry?: { __typename: 'RoutinesTimeTrackingEvaluationArtistry', duration?: number | null, ratio?: number | null } | null, communication?: { __typename: 'RoutinesTimeTrackingEvaluationCommunication', duration?: number | null, ratio?: number | null } | null, tricks?: { __typename: 'RoutinesTimeTrackingEvaluationTricks', duration?: number | null, ratio?: number | null } | null, filler?: { __typename: 'RoutinesTimeTrackingEvaluationFiller', duration?: number | null, ratio?: number | null } | null, void?: { __typename: 'RoutinesTimeTrackingEvaluationVoid', duration?: number | null, ratio?: number | null } | null, dismounts?: { __typename: 'RoutinesTimeTrackingEvaluationDismounts', duration?: number | null, ratio?: number | null } | null } | null } | null, artistic?: { __typename: 'RoutinesArtistic', name: string, score?: number | null, parts?: Array<{ __typename: 'RoutinesArtisticParts', name: string, score?: number | null, categories?: Array<{ __typename: 'RoutinesArtisticPartsCategories', name: string, score?: number | null, criteria?: Array<{ __typename: 'RoutinesArtisticPartsCategoriesCriteria', name: string, value?: number | null } | null> | null } | null> | null } | null> | null } | null } | null } | null> | null } };

export const SkillPartsFragmentDoc = gql`
    fragment SkillParts on Skill {
  __typename
  title
  body
}
    `;
export const TechniquePartsFragmentDoc = gql`
    fragment TechniqueParts on Technique {
  __typename
  title
  body
  art {
    ... on Art {
      __typename
      title
      parent {
        ... on Art {
          __typename
          title
          video
          links {
            __typename
            label
            url
          }
          body
        }
        ... on Document {
          _sys {
            filename
            basename
            breadcrumbs
            path
            relativePath
            extension
          }
          id
        }
      }
      video
      links {
        __typename
        label
        url
      }
      body
    }
    ... on Document {
      _sys {
        filename
        basename
        breadcrumbs
        path
        relativePath
        extension
      }
      id
    }
  }
  links {
    __typename
    label
    url
  }
}
    `;
export const ArtPartsFragmentDoc = gql`
    fragment ArtParts on Art {
  __typename
  title
  parent {
    ... on Art {
      __typename
      title
      parent {
        ... on Art {
          __typename
          title
          video
          links {
            __typename
            label
            url
          }
          body
        }
        ... on Document {
          _sys {
            filename
            basename
            breadcrumbs
            path
            relativePath
            extension
          }
          id
        }
      }
      video
      links {
        __typename
        label
        url
      }
      body
    }
    ... on Document {
      _sys {
        filename
        basename
        breadcrumbs
        path
        relativePath
        extension
      }
      id
    }
  }
  video
  links {
    __typename
    label
    url
  }
  body
}
    `;
export const MovePartsFragmentDoc = gql`
    fragment MoveParts on Move {
  __typename
  title
  art {
    ... on Art {
      __typename
      title
      parent {
        ... on Art {
          __typename
          title
          video
          links {
            __typename
            label
            url
          }
          body
        }
        ... on Document {
          _sys {
            filename
            basename
            breadcrumbs
            path
            relativePath
            extension
          }
          id
        }
      }
      video
      links {
        __typename
        label
        url
      }
      body
    }
    ... on Document {
      _sys {
        filename
        basename
        breadcrumbs
        path
        relativePath
        extension
      }
      id
    }
  }
  description
  instruction
  video
  links {
    __typename
    label
    url
  }
  moves {
    __typename
    data {
      ... on Move {
        __typename
        title
        art {
          ... on Art {
            __typename
            title
            video
            links {
              __typename
              label
              url
            }
            body
          }
          ... on Document {
            _sys {
              filename
              basename
              breadcrumbs
              path
              relativePath
              extension
            }
            id
          }
        }
        description
        instruction
        video
        links {
          __typename
          label
          url
        }
        moves {
          __typename
          data {
            ... on Move {
              __typename
              title
              description
              instruction
              video
              links {
                __typename
                label
                url
              }
              moves {
                __typename
              }
              body
              tags
            }
            ... on Document {
              _sys {
                filename
                basename
                breadcrumbs
                path
                relativePath
                extension
              }
              id
            }
          }
        }
        body
        tags
      }
      ... on Document {
        _sys {
          filename
          basename
          breadcrumbs
          path
          relativePath
          extension
        }
        id
      }
    }
  }
  body
  tags
}
    `;
export const ExercisePartsFragmentDoc = gql`
    fragment ExerciseParts on Exercise {
  __typename
  title
  excerpt
  body
  media {
    __typename
    ... on ExerciseMediaDancemix {
      label
      duration
      pause
      amount
      playlist
    }
    ... on ExerciseMediaSong {
      id
      play
      start
    }
    ... on ExerciseMediaLoop {
      name
    }
    ... on ExerciseMediaMaterial {
      material
    }
  }
  instruction {
    __typename
    title
    move {
      ... on Move {
        __typename
        title
        art {
          ... on Art {
            __typename
            title
            video
            links {
              __typename
              label
              url
            }
            body
          }
          ... on Document {
            _sys {
              filename
              basename
              breadcrumbs
              path
              relativePath
              extension
            }
            id
          }
        }
        description
        instruction
        video
        links {
          __typename
          label
          url
        }
        moves {
          __typename
          data {
            ... on Move {
              __typename
              title
              description
              instruction
              video
              links {
                __typename
                label
                url
              }
              moves {
                __typename
              }
              body
              tags
            }
            ... on Document {
              _sys {
                filename
                basename
                breadcrumbs
                path
                relativePath
                extension
              }
              id
            }
          }
        }
        body
        tags
      }
      ... on Document {
        _sys {
          filename
          basename
          breadcrumbs
          path
          relativePath
          extension
        }
        id
      }
    }
    duration
    content
    method
    goal
    media {
      __typename
      ... on ExerciseInstructionMediaDancemix {
        label
        duration
        pause
        amount
        playlist
      }
      ... on ExerciseInstructionMediaSong {
        id
        play
        start
      }
      ... on ExerciseInstructionMediaLoop {
        name
      }
      ... on ExerciseInstructionMediaMaterial {
        material
      }
    }
  }
  difficulty
  locomotion
  personal
  tags
  exercises {
    __typename
    data {
      ... on Exercise {
        __typename
        title
        excerpt
        body
        media {
          __typename
          ... on ExerciseMediaDancemix {
            label
            duration
            pause
            amount
            playlist
          }
          ... on ExerciseMediaSong {
            id
            play
            start
          }
          ... on ExerciseMediaLoop {
            name
          }
          ... on ExerciseMediaMaterial {
            material
          }
        }
        instruction {
          __typename
          title
          move {
            ... on Move {
              __typename
              title
              description
              instruction
              video
              links {
                __typename
                label
                url
              }
              moves {
                __typename
              }
              body
              tags
            }
            ... on Document {
              _sys {
                filename
                basename
                breadcrumbs
                path
                relativePath
                extension
              }
              id
            }
          }
          duration
          content
          method
          goal
          media {
            __typename
            ... on ExerciseInstructionMediaDancemix {
              label
              duration
              pause
              amount
              playlist
            }
            ... on ExerciseInstructionMediaSong {
              id
              play
              start
            }
            ... on ExerciseInstructionMediaLoop {
              name
            }
            ... on ExerciseInstructionMediaMaterial {
              material
            }
          }
        }
        difficulty
        locomotion
        personal
        tags
        exercises {
          __typename
          data {
            ... on Exercise {
              __typename
              title
              excerpt
              body
              media {
                __typename
                ... on ExerciseMediaDancemix {
                  label
                  duration
                  pause
                  amount
                  playlist
                }
                ... on ExerciseMediaSong {
                  id
                  play
                  start
                }
                ... on ExerciseMediaLoop {
                  name
                }
                ... on ExerciseMediaMaterial {
                  material
                }
              }
              instruction {
                __typename
                title
                duration
                content
                method
                goal
                media {
                  __typename
                  ... on ExerciseInstructionMediaDancemix {
                    label
                    duration
                    pause
                    amount
                    playlist
                  }
                  ... on ExerciseInstructionMediaSong {
                    id
                    play
                    start
                  }
                  ... on ExerciseInstructionMediaLoop {
                    name
                  }
                  ... on ExerciseInstructionMediaMaterial {
                    material
                  }
                }
              }
              difficulty
              locomotion
              personal
              tags
              exercises {
                __typename
              }
              links {
                __typename
                label
                url
              }
              video
              skills {
                __typename
              }
            }
            ... on Document {
              _sys {
                filename
                basename
                breadcrumbs
                path
                relativePath
                extension
              }
              id
            }
          }
        }
        links {
          __typename
          label
          url
        }
        video
        art {
          ... on Art {
            __typename
            title
            video
            links {
              __typename
              label
              url
            }
            body
          }
          ... on Document {
            _sys {
              filename
              basename
              breadcrumbs
              path
              relativePath
              extension
            }
            id
          }
        }
        technique {
          ... on Technique {
            __typename
            title
            body
            links {
              __typename
              label
              url
            }
          }
          ... on Document {
            _sys {
              filename
              basename
              breadcrumbs
              path
              relativePath
              extension
            }
            id
          }
        }
        skills {
          __typename
          data {
            ... on Skill {
              __typename
              title
              body
            }
            ... on Document {
              _sys {
                filename
                basename
                breadcrumbs
                path
                relativePath
                extension
              }
              id
            }
          }
        }
      }
      ... on Document {
        _sys {
          filename
          basename
          breadcrumbs
          path
          relativePath
          extension
        }
        id
      }
    }
  }
  links {
    __typename
    label
    url
  }
  video
  art {
    ... on Art {
      __typename
      title
      parent {
        ... on Art {
          __typename
          title
          video
          links {
            __typename
            label
            url
          }
          body
        }
        ... on Document {
          _sys {
            filename
            basename
            breadcrumbs
            path
            relativePath
            extension
          }
          id
        }
      }
      video
      links {
        __typename
        label
        url
      }
      body
    }
    ... on Document {
      _sys {
        filename
        basename
        breadcrumbs
        path
        relativePath
        extension
      }
      id
    }
  }
  technique {
    ... on Technique {
      __typename
      title
      body
      art {
        ... on Art {
          __typename
          title
          video
          links {
            __typename
            label
            url
          }
          body
        }
        ... on Document {
          _sys {
            filename
            basename
            breadcrumbs
            path
            relativePath
            extension
          }
          id
        }
      }
      links {
        __typename
        label
        url
      }
    }
    ... on Document {
      _sys {
        filename
        basename
        breadcrumbs
        path
        relativePath
        extension
      }
      id
    }
  }
  skills {
    __typename
    data {
      ... on Skill {
        __typename
        title
        body
      }
      ... on Document {
        _sys {
          filename
          basename
          breadcrumbs
          path
          relativePath
          extension
        }
        id
      }
    }
  }
}
    `;
export const CoursePartsFragmentDoc = gql`
    fragment CourseParts on Course {
  __typename
  title
  description
  about
  learn
  examples
  lessons {
    __typename
    ... on CourseLessonsLesson {
      title
      description
      exercises {
        __typename
        data {
          ... on Exercise {
            __typename
            title
            excerpt
            body
            media {
              __typename
              ... on ExerciseMediaDancemix {
                label
                duration
                pause
                amount
                playlist
              }
              ... on ExerciseMediaSong {
                id
                play
                start
              }
              ... on ExerciseMediaLoop {
                name
              }
              ... on ExerciseMediaMaterial {
                material
              }
            }
            instruction {
              __typename
              title
              move {
                ... on Move {
                  __typename
                  title
                  description
                  instruction
                  video
                  links {
                    __typename
                    label
                    url
                  }
                  moves {
                    __typename
                  }
                  body
                  tags
                }
                ... on Document {
                  _sys {
                    filename
                    basename
                    breadcrumbs
                    path
                    relativePath
                    extension
                  }
                  id
                }
              }
              duration
              content
              method
              goal
              media {
                __typename
                ... on ExerciseInstructionMediaDancemix {
                  label
                  duration
                  pause
                  amount
                  playlist
                }
                ... on ExerciseInstructionMediaSong {
                  id
                  play
                  start
                }
                ... on ExerciseInstructionMediaLoop {
                  name
                }
                ... on ExerciseInstructionMediaMaterial {
                  material
                }
              }
            }
            difficulty
            locomotion
            personal
            tags
            exercises {
              __typename
              data {
                ... on Exercise {
                  __typename
                  title
                  excerpt
                  body
                  media {
                    __typename
                    ... on ExerciseMediaDancemix {
                      label
                      duration
                      pause
                      amount
                      playlist
                    }
                    ... on ExerciseMediaSong {
                      id
                      play
                      start
                    }
                    ... on ExerciseMediaLoop {
                      name
                    }
                    ... on ExerciseMediaMaterial {
                      material
                    }
                  }
                  instruction {
                    __typename
                    title
                    duration
                    content
                    method
                    goal
                    media {
                      __typename
                      ... on ExerciseInstructionMediaDancemix {
                        label
                        duration
                        pause
                        amount
                        playlist
                      }
                      ... on ExerciseInstructionMediaSong {
                        id
                        play
                        start
                      }
                      ... on ExerciseInstructionMediaLoop {
                        name
                      }
                      ... on ExerciseInstructionMediaMaterial {
                        material
                      }
                    }
                  }
                  difficulty
                  locomotion
                  personal
                  tags
                  exercises {
                    __typename
                  }
                  links {
                    __typename
                    label
                    url
                  }
                  video
                  skills {
                    __typename
                  }
                }
                ... on Document {
                  _sys {
                    filename
                    basename
                    breadcrumbs
                    path
                    relativePath
                    extension
                  }
                  id
                }
              }
            }
            links {
              __typename
              label
              url
            }
            video
            art {
              ... on Art {
                __typename
                title
                video
                links {
                  __typename
                  label
                  url
                }
                body
              }
              ... on Document {
                _sys {
                  filename
                  basename
                  breadcrumbs
                  path
                  relativePath
                  extension
                }
                id
              }
            }
            technique {
              ... on Technique {
                __typename
                title
                body
                links {
                  __typename
                  label
                  url
                }
              }
              ... on Document {
                _sys {
                  filename
                  basename
                  breadcrumbs
                  path
                  relativePath
                  extension
                }
                id
              }
            }
            skills {
              __typename
              data {
                ... on Skill {
                  __typename
                  title
                  body
                }
                ... on Document {
                  _sys {
                    filename
                    basename
                    breadcrumbs
                    path
                    relativePath
                    extension
                  }
                  id
                }
              }
            }
          }
          ... on Document {
            _sys {
              filename
              basename
              breadcrumbs
              path
              relativePath
              extension
            }
            id
          }
        }
      }
    }
  }
}
    `;
export const AwfulpracticePartsFragmentDoc = gql`
    fragment AwfulpracticeParts on Awfulpractice {
  __typename
  title
  tags
  body
}
    `;
export const RoutinesPartsFragmentDoc = gql`
    fragment RoutinesParts on Routines {
  __typename
  rider
  type
  event
  date
  video
  timeTracking {
    __typename
    start
    end
    scenes {
      __typename
      start
      end
      category
    }
    duration
    evaluation {
      __typename
      artistry {
        __typename
        duration
        ratio
      }
      communication {
        __typename
        duration
        ratio
      }
      tricks {
        __typename
        duration
        ratio
      }
      filler {
        __typename
        duration
        ratio
      }
      void {
        __typename
        duration
        ratio
      }
      dismounts {
        __typename
        duration
        ratio
      }
    }
  }
  artistic {
    __typename
    name
    score
    parts {
      __typename
      name
      score
      categories {
        __typename
        name
        score
        criteria {
          __typename
          name
          value
        }
      }
    }
  }
  notTodoList
}
    `;
export const SkillDocument = gql`
    query skill($relativePath: String!) {
  skill(relativePath: $relativePath) {
    ... on Document {
      _sys {
        filename
        basename
        breadcrumbs
        path
        relativePath
        extension
      }
      id
    }
    ...SkillParts
  }
}
    ${SkillPartsFragmentDoc}`;
export const SkillConnectionDocument = gql`
    query skillConnection($before: String, $after: String, $first: Float, $last: Float, $sort: String, $filter: SkillFilter) {
  skillConnection(
    before: $before
    after: $after
    first: $first
    last: $last
    sort: $sort
    filter: $filter
  ) {
    pageInfo {
      hasPreviousPage
      hasNextPage
      startCursor
      endCursor
    }
    totalCount
    edges {
      cursor
      node {
        ... on Document {
          _sys {
            filename
            basename
            breadcrumbs
            path
            relativePath
            extension
          }
          id
        }
        ...SkillParts
      }
    }
  }
}
    ${SkillPartsFragmentDoc}`;
export const TechniqueDocument = gql`
    query technique($relativePath: String!) {
  technique(relativePath: $relativePath) {
    ... on Document {
      _sys {
        filename
        basename
        breadcrumbs
        path
        relativePath
        extension
      }
      id
    }
    ...TechniqueParts
  }
}
    ${TechniquePartsFragmentDoc}`;
export const TechniqueConnectionDocument = gql`
    query techniqueConnection($before: String, $after: String, $first: Float, $last: Float, $sort: String, $filter: TechniqueFilter) {
  techniqueConnection(
    before: $before
    after: $after
    first: $first
    last: $last
    sort: $sort
    filter: $filter
  ) {
    pageInfo {
      hasPreviousPage
      hasNextPage
      startCursor
      endCursor
    }
    totalCount
    edges {
      cursor
      node {
        ... on Document {
          _sys {
            filename
            basename
            breadcrumbs
            path
            relativePath
            extension
          }
          id
        }
        ...TechniqueParts
      }
    }
  }
}
    ${TechniquePartsFragmentDoc}`;
export const ArtDocument = gql`
    query art($relativePath: String!) {
  art(relativePath: $relativePath) {
    ... on Document {
      _sys {
        filename
        basename
        breadcrumbs
        path
        relativePath
        extension
      }
      id
    }
    ...ArtParts
  }
}
    ${ArtPartsFragmentDoc}`;
export const ArtConnectionDocument = gql`
    query artConnection($before: String, $after: String, $first: Float, $last: Float, $sort: String, $filter: ArtFilter) {
  artConnection(
    before: $before
    after: $after
    first: $first
    last: $last
    sort: $sort
    filter: $filter
  ) {
    pageInfo {
      hasPreviousPage
      hasNextPage
      startCursor
      endCursor
    }
    totalCount
    edges {
      cursor
      node {
        ... on Document {
          _sys {
            filename
            basename
            breadcrumbs
            path
            relativePath
            extension
          }
          id
        }
        ...ArtParts
      }
    }
  }
}
    ${ArtPartsFragmentDoc}`;
export const MoveDocument = gql`
    query move($relativePath: String!) {
  move(relativePath: $relativePath) {
    ... on Document {
      _sys {
        filename
        basename
        breadcrumbs
        path
        relativePath
        extension
      }
      id
    }
    ...MoveParts
  }
}
    ${MovePartsFragmentDoc}`;
export const MoveConnectionDocument = gql`
    query moveConnection($before: String, $after: String, $first: Float, $last: Float, $sort: String, $filter: MoveFilter) {
  moveConnection(
    before: $before
    after: $after
    first: $first
    last: $last
    sort: $sort
    filter: $filter
  ) {
    pageInfo {
      hasPreviousPage
      hasNextPage
      startCursor
      endCursor
    }
    totalCount
    edges {
      cursor
      node {
        ... on Document {
          _sys {
            filename
            basename
            breadcrumbs
            path
            relativePath
            extension
          }
          id
        }
        ...MoveParts
      }
    }
  }
}
    ${MovePartsFragmentDoc}`;
export const ExerciseDocument = gql`
    query exercise($relativePath: String!) {
  exercise(relativePath: $relativePath) {
    ... on Document {
      _sys {
        filename
        basename
        breadcrumbs
        path
        relativePath
        extension
      }
      id
    }
    ...ExerciseParts
  }
}
    ${ExercisePartsFragmentDoc}`;
export const ExerciseConnectionDocument = gql`
    query exerciseConnection($before: String, $after: String, $first: Float, $last: Float, $sort: String, $filter: ExerciseFilter) {
  exerciseConnection(
    before: $before
    after: $after
    first: $first
    last: $last
    sort: $sort
    filter: $filter
  ) {
    pageInfo {
      hasPreviousPage
      hasNextPage
      startCursor
      endCursor
    }
    totalCount
    edges {
      cursor
      node {
        ... on Document {
          _sys {
            filename
            basename
            breadcrumbs
            path
            relativePath
            extension
          }
          id
        }
        ...ExerciseParts
      }
    }
  }
}
    ${ExercisePartsFragmentDoc}`;
export const CourseDocument = gql`
    query course($relativePath: String!) {
  course(relativePath: $relativePath) {
    ... on Document {
      _sys {
        filename
        basename
        breadcrumbs
        path
        relativePath
        extension
      }
      id
    }
    ...CourseParts
  }
}
    ${CoursePartsFragmentDoc}`;
export const CourseConnectionDocument = gql`
    query courseConnection($before: String, $after: String, $first: Float, $last: Float, $sort: String, $filter: CourseFilter) {
  courseConnection(
    before: $before
    after: $after
    first: $first
    last: $last
    sort: $sort
    filter: $filter
  ) {
    pageInfo {
      hasPreviousPage
      hasNextPage
      startCursor
      endCursor
    }
    totalCount
    edges {
      cursor
      node {
        ... on Document {
          _sys {
            filename
            basename
            breadcrumbs
            path
            relativePath
            extension
          }
          id
        }
        ...CourseParts
      }
    }
  }
}
    ${CoursePartsFragmentDoc}`;
export const AwfulpracticeDocument = gql`
    query awfulpractice($relativePath: String!) {
  awfulpractice(relativePath: $relativePath) {
    ... on Document {
      _sys {
        filename
        basename
        breadcrumbs
        path
        relativePath
        extension
      }
      id
    }
    ...AwfulpracticeParts
  }
}
    ${AwfulpracticePartsFragmentDoc}`;
export const AwfulpracticeConnectionDocument = gql`
    query awfulpracticeConnection($before: String, $after: String, $first: Float, $last: Float, $sort: String, $filter: AwfulpracticeFilter) {
  awfulpracticeConnection(
    before: $before
    after: $after
    first: $first
    last: $last
    sort: $sort
    filter: $filter
  ) {
    pageInfo {
      hasPreviousPage
      hasNextPage
      startCursor
      endCursor
    }
    totalCount
    edges {
      cursor
      node {
        ... on Document {
          _sys {
            filename
            basename
            breadcrumbs
            path
            relativePath
            extension
          }
          id
        }
        ...AwfulpracticeParts
      }
    }
  }
}
    ${AwfulpracticePartsFragmentDoc}`;
export const RoutinesDocument = gql`
    query routines($relativePath: String!) {
  routines(relativePath: $relativePath) {
    ... on Document {
      _sys {
        filename
        basename
        breadcrumbs
        path
        relativePath
        extension
      }
      id
    }
    ...RoutinesParts
  }
}
    ${RoutinesPartsFragmentDoc}`;
export const RoutinesConnectionDocument = gql`
    query routinesConnection($before: String, $after: String, $first: Float, $last: Float, $sort: String, $filter: RoutinesFilter) {
  routinesConnection(
    before: $before
    after: $after
    first: $first
    last: $last
    sort: $sort
    filter: $filter
  ) {
    pageInfo {
      hasPreviousPage
      hasNextPage
      startCursor
      endCursor
    }
    totalCount
    edges {
      cursor
      node {
        ... on Document {
          _sys {
            filename
            basename
            breadcrumbs
            path
            relativePath
            extension
          }
          id
        }
        ...RoutinesParts
      }
    }
  }
}
    ${RoutinesPartsFragmentDoc}`;
export type Requester<C= {}> = <R, V>(doc: DocumentNode, vars?: V, options?: C) => Promise<R>
  export function getSdk<C>(requester: Requester<C>) {
    return {
      skill(variables: SkillQueryVariables, options?: C): Promise<{data: SkillQuery, errors?: { message: string, locations: { line: number, column: number }[], path: string[] }[], variables: SkillQueryVariables, query: string}> {
        return requester<{data: SkillQuery, errors?: { message: string, locations: { line: number, column: number }[], path: string[] }[], variables: SkillQueryVariables, query: string}, SkillQueryVariables>(SkillDocument, variables, options);
      },
    skillConnection(variables?: SkillConnectionQueryVariables, options?: C): Promise<{data: SkillConnectionQuery, errors?: { message: string, locations: { line: number, column: number }[], path: string[] }[], variables: SkillConnectionQueryVariables, query: string}> {
        return requester<{data: SkillConnectionQuery, errors?: { message: string, locations: { line: number, column: number }[], path: string[] }[], variables: SkillConnectionQueryVariables, query: string}, SkillConnectionQueryVariables>(SkillConnectionDocument, variables, options);
      },
    technique(variables: TechniqueQueryVariables, options?: C): Promise<{data: TechniqueQuery, errors?: { message: string, locations: { line: number, column: number }[], path: string[] }[], variables: TechniqueQueryVariables, query: string}> {
        return requester<{data: TechniqueQuery, errors?: { message: string, locations: { line: number, column: number }[], path: string[] }[], variables: TechniqueQueryVariables, query: string}, TechniqueQueryVariables>(TechniqueDocument, variables, options);
      },
    techniqueConnection(variables?: TechniqueConnectionQueryVariables, options?: C): Promise<{data: TechniqueConnectionQuery, errors?: { message: string, locations: { line: number, column: number }[], path: string[] }[], variables: TechniqueConnectionQueryVariables, query: string}> {
        return requester<{data: TechniqueConnectionQuery, errors?: { message: string, locations: { line: number, column: number }[], path: string[] }[], variables: TechniqueConnectionQueryVariables, query: string}, TechniqueConnectionQueryVariables>(TechniqueConnectionDocument, variables, options);
      },
    art(variables: ArtQueryVariables, options?: C): Promise<{data: ArtQuery, errors?: { message: string, locations: { line: number, column: number }[], path: string[] }[], variables: ArtQueryVariables, query: string}> {
        return requester<{data: ArtQuery, errors?: { message: string, locations: { line: number, column: number }[], path: string[] }[], variables: ArtQueryVariables, query: string}, ArtQueryVariables>(ArtDocument, variables, options);
      },
    artConnection(variables?: ArtConnectionQueryVariables, options?: C): Promise<{data: ArtConnectionQuery, errors?: { message: string, locations: { line: number, column: number }[], path: string[] }[], variables: ArtConnectionQueryVariables, query: string}> {
        return requester<{data: ArtConnectionQuery, errors?: { message: string, locations: { line: number, column: number }[], path: string[] }[], variables: ArtConnectionQueryVariables, query: string}, ArtConnectionQueryVariables>(ArtConnectionDocument, variables, options);
      },
    move(variables: MoveQueryVariables, options?: C): Promise<{data: MoveQuery, errors?: { message: string, locations: { line: number, column: number }[], path: string[] }[], variables: MoveQueryVariables, query: string}> {
        return requester<{data: MoveQuery, errors?: { message: string, locations: { line: number, column: number }[], path: string[] }[], variables: MoveQueryVariables, query: string}, MoveQueryVariables>(MoveDocument, variables, options);
      },
    moveConnection(variables?: MoveConnectionQueryVariables, options?: C): Promise<{data: MoveConnectionQuery, errors?: { message: string, locations: { line: number, column: number }[], path: string[] }[], variables: MoveConnectionQueryVariables, query: string}> {
        return requester<{data: MoveConnectionQuery, errors?: { message: string, locations: { line: number, column: number }[], path: string[] }[], variables: MoveConnectionQueryVariables, query: string}, MoveConnectionQueryVariables>(MoveConnectionDocument, variables, options);
      },
    exercise(variables: ExerciseQueryVariables, options?: C): Promise<{data: ExerciseQuery, errors?: { message: string, locations: { line: number, column: number }[], path: string[] }[], variables: ExerciseQueryVariables, query: string}> {
        return requester<{data: ExerciseQuery, errors?: { message: string, locations: { line: number, column: number }[], path: string[] }[], variables: ExerciseQueryVariables, query: string}, ExerciseQueryVariables>(ExerciseDocument, variables, options);
      },
    exerciseConnection(variables?: ExerciseConnectionQueryVariables, options?: C): Promise<{data: ExerciseConnectionQuery, errors?: { message: string, locations: { line: number, column: number }[], path: string[] }[], variables: ExerciseConnectionQueryVariables, query: string}> {
        return requester<{data: ExerciseConnectionQuery, errors?: { message: string, locations: { line: number, column: number }[], path: string[] }[], variables: ExerciseConnectionQueryVariables, query: string}, ExerciseConnectionQueryVariables>(ExerciseConnectionDocument, variables, options);
      },
    course(variables: CourseQueryVariables, options?: C): Promise<{data: CourseQuery, errors?: { message: string, locations: { line: number, column: number }[], path: string[] }[], variables: CourseQueryVariables, query: string}> {
        return requester<{data: CourseQuery, errors?: { message: string, locations: { line: number, column: number }[], path: string[] }[], variables: CourseQueryVariables, query: string}, CourseQueryVariables>(CourseDocument, variables, options);
      },
    courseConnection(variables?: CourseConnectionQueryVariables, options?: C): Promise<{data: CourseConnectionQuery, errors?: { message: string, locations: { line: number, column: number }[], path: string[] }[], variables: CourseConnectionQueryVariables, query: string}> {
        return requester<{data: CourseConnectionQuery, errors?: { message: string, locations: { line: number, column: number }[], path: string[] }[], variables: CourseConnectionQueryVariables, query: string}, CourseConnectionQueryVariables>(CourseConnectionDocument, variables, options);
      },
    awfulpractice(variables: AwfulpracticeQueryVariables, options?: C): Promise<{data: AwfulpracticeQuery, errors?: { message: string, locations: { line: number, column: number }[], path: string[] }[], variables: AwfulpracticeQueryVariables, query: string}> {
        return requester<{data: AwfulpracticeQuery, errors?: { message: string, locations: { line: number, column: number }[], path: string[] }[], variables: AwfulpracticeQueryVariables, query: string}, AwfulpracticeQueryVariables>(AwfulpracticeDocument, variables, options);
      },
    awfulpracticeConnection(variables?: AwfulpracticeConnectionQueryVariables, options?: C): Promise<{data: AwfulpracticeConnectionQuery, errors?: { message: string, locations: { line: number, column: number }[], path: string[] }[], variables: AwfulpracticeConnectionQueryVariables, query: string}> {
        return requester<{data: AwfulpracticeConnectionQuery, errors?: { message: string, locations: { line: number, column: number }[], path: string[] }[], variables: AwfulpracticeConnectionQueryVariables, query: string}, AwfulpracticeConnectionQueryVariables>(AwfulpracticeConnectionDocument, variables, options);
      },
    routines(variables: RoutinesQueryVariables, options?: C): Promise<{data: RoutinesQuery, errors?: { message: string, locations: { line: number, column: number }[], path: string[] }[], variables: RoutinesQueryVariables, query: string}> {
        return requester<{data: RoutinesQuery, errors?: { message: string, locations: { line: number, column: number }[], path: string[] }[], variables: RoutinesQueryVariables, query: string}, RoutinesQueryVariables>(RoutinesDocument, variables, options);
      },
    routinesConnection(variables?: RoutinesConnectionQueryVariables, options?: C): Promise<{data: RoutinesConnectionQuery, errors?: { message: string, locations: { line: number, column: number }[], path: string[] }[], variables: RoutinesConnectionQueryVariables, query: string}> {
        return requester<{data: RoutinesConnectionQuery, errors?: { message: string, locations: { line: number, column: number }[], path: string[] }[], variables: RoutinesConnectionQueryVariables, query: string}, RoutinesConnectionQueryVariables>(RoutinesConnectionDocument, variables, options);
      }
    };
  }
  export type Sdk = ReturnType<typeof getSdk>;

// TinaSDK generated code
import { createClient, TinaClient } from "tinacms/dist/client";

const generateRequester = (
  client: TinaClient,
) => {
  const requester: (
    doc: any,
    vars?: any,
    options?: {
      branch?: string,
      /**
       * Aside from `method` and `body`, all fetch options are passed
       * through to underlying fetch request
       */
      fetchOptions?: Omit<Parameters<typeof fetch>[1], 'body' | 'method'>,
    },
    client
  ) => Promise<any> = async (doc, vars, options) => {
    let url = client.apiUrl
    if (options?.branch) {
      const index = client.apiUrl.lastIndexOf('/')
      url = client.apiUrl.substring(0, index + 1) + options.branch
    }
    const data = await client.request({
      query: doc,
      variables: vars,
      url,
    }, options)

    return { data: data?.data, errors: data?.errors, query: doc, variables: vars || {} }
  }

  return requester
}

/**
 * @experimental this class can be used but may change in the future
 **/
export const ExperimentalGetTinaClient = () =>
  getSdk(
    generateRequester(
      createClient({
        url: "https://content.tinajs.io/1.5/content/dac872ef-1f43-4f71-8513-1cb789e62a6f/github/main",
        queries,
      })
    )
  )

export const queries = (
  client: TinaClient,
) => {
  const requester = generateRequester(client)
  return getSdk(requester)
}

  